<template>
  <div
    class="center_content"
    ref="cenBox"
    @scroll.passive="allScrollTop($event)"
  >
    <div class="detaBox">
      <div class="anliMiddle">
        <div class="anliBox">
          <div class="anliImg">
            <img
              :src="
                anliBox[0] && anliBox[0].info && anliBox[0].info.cover.length
                  ? anliBox[0].info.cover[0].url
                  : noBanner
              "
              alt=""
            />
          </div>
          <div class="anliNav">
            <div>
              项目名称：{{
                anliBox[0] && anliBox[0].info ? anliBox[0].info.title : ""
              }}
            </div>
            <div>创建人：{{ anliBox[0] ? anliBox[0].name : "" }}</div>
            <div>
              <div>单位：{{ anliBox[0] ? anliBox[0].schoolName : "" }}</div>
              <div>
                案例组别：{{
                  anliBox[0] && anliBox[0].typename
                    ? anliBox[0].typename
                    : "暂无分类"
                }}
              </div>
            </div>
            <div class="personAndAutor">
              <div>总人数：</div>
              <div class="people">
                <div class="man">
                  <img src="../../../../assets/people.png" alt />
                </div>
                <div class="person">
                  {{
                    anliBox[0]
                      ? anliBox[0].info.autor.length +
                        anliBox[0].info.tableData.length
                      : 0
                  }}人
                </div>
              </div>
              <div class="autorBox" v-if="anliBox[0].info.autor.length">
                <div>联系人：</div>
                <div v-for="(a, aIndex) in anliBox[0].info.autor" :key="aIndex">
                  {{ a.sn }}
                </div>
              </div>
              <div class="autorBox" v-if="anliBox[0].info.tableData.length">
                <div>协作者：</div>
                <div
                  class="Autor"
                  v-for="(a, aIndex) in anliBox[0].info.tableData"
                  :key="aIndex"
                >
                  {{ a.sn }}
                </div>
              </div>
            </div>
          </div>
          <div class="getScore" v-if="$store.state.userInfo.type != 1">
            <el-button @click="openScore(anliBox[0])">评分</el-button>
          </div>
        </div>
      </div>
      <div class="navBox" :class="{ isNavBox: isNavTop >= 300 }">
        <div class="navTop" @click="isShow = 0">
          <div class="navImg" style="width: 24px">
            <img src="../../../../assets/icon/anliDetail/proOver.png" alt="" />
          </div>
          <div>项目基础信息</div>
        </div>
        <div class="navTop" @click="isShow = 1">
          <div class="navImg">
            <img
              src="../../../../assets/icon/anliDetail/proOverTwo.png"
              alt=""
            />
          </div>
          <div>平台案例填写</div>
        </div>
        <!-- <div class="navTop" @click="jump('third')">
          <div class="navImg">
            <img src="../../../../assets/icon/anliDetail/learnObj.png" alt="" />
          </div>
          <div>项目安排</div>
        </div>
        <div class="navTop" @click="jump('fouth')">
          <div class="navImg">
            <img src="../../../../assets/icon/anliDetail/process.png" alt="" />
          </div>
          <div>项目活动过程</div>
        </div>
        <div class="navTop" @click="jump('fivth')">
          <div class="navImg">
            <img src="../../../../assets/icon/anliDetail/proEva.png" alt="" />
          </div>
          <div>项目成果交流与评价</div>
        </div>
        <div class="navTop" @click="jump('sixth')">
          <div class="navImg">
            <img src="../../../../assets/icon/anliDetail/proEff.png" alt="" />
          </div>
          <div>项目成效与反思</div>
        </div> -->
      </div>

      <div
        class="isNoMessage"
        v-if="
          anliBox[0].info.courseText == '' &&
          anliBox[0].info.imgBox.length == 0 &&
          anliBox[0].info.data.length == 0 &&
          anliBox[0].overview.driQuestion.brief == '' &&
          anliBox[0].overview.driQuestion.imgBox.length == 0 &&
          anliBox[0].overview.tarDesign.brief == '' &&
          anliBox[0].overview.tarDesign.imgBox.length == 0 &&
          anliBox[0].overview.actiDesign.brief == '' &&
          anliBox[0].overview.actiDesign.imgBox.length == 0 &&
          anliBox[0].process.stageBox[0].staTitle == '' &&
          anliBox[0].process.stageBox[0].actBox[0].actName == '' &&
          anliBox[0].process.stageBox[0].brief == '' &&
          anliBox[0].process.stageBox[0].data.length == 0 &&
          anliBox[0].proexc.brief == '' &&
          anliBox[0].proexc.imgBox.length == 0 &&
          anliBox[0].results.brief == '' &&
          anliBox[0].results.imgBox.length == 0
        "
      >
        <img src="../../../../assets/icon/race/isNoMessage.png" alt />
      </div>
      <div class="messageBox" v-else :class="{ isMessageBox: isNavTop >= 300 }">
        <div
          class="leftNav"
          :class="{ isleftNav: isNavTop >= 300 }"
          v-if="
            isShow == 1 &&
            anliBox[0].overview.driQuestion.brief != '' &&
            anliBox[0].overview.tarDesign.brief != '' &&
            anliBox[0].overview.actiDesign.brief != '' &&
            anliBox[0].process.stageBox[0].staTitle != '' &&
            anliBox[0].process.stageBox[0].actBox[0].actName != '' &&
            anliBox[0].process.stageBox[0].brief != '' &&
            anliBox[0].process.stageBox[0].data.length > 0 &&
            anliBox[0].proexc.brief != '' &&
            anliBox[0].results.brief != ''
          "
        >
          <div class="topNav">导航栏</div>
          <div class="navLeftBox">
            <!-- <div class="navBTitle" @click="jump('first')">一、项目基础信息</div>
            <div class="navBTitle" @click="jump('first')">1、基础信息</div>
            <div class="navLTitle" @click="jump('first')">
              <div>1.1</div>
              <div>项目简介</div>
            </div>
            <div class="navBTitle" @click="jump('second')">
              二、平台案例填写
            </div> -->
            <div class="navBTitle" @click="jump('second')">1、项目概况</div>
            <div class="navLTitle" @click="jump('second')">
              <div>1.1</div>
              <div>驱动问题</div>
            </div>
            <div class="navLTitle" @click="jump('xx')">
              <div>1.2</div>
              <div>学习目标</div>
            </div>
            <div class="navLTitle" @click="jump('pj')">
              <div>1.3</div>
              <div>评价设计</div>
            </div>
            <div class="navBTitle" @click="jumpS(0)">2、项目安排</div>
            <div
              class="navLTitle"
              v-for="(s, si) in anliBox[0].process.stageBox"
              :key="si"
              @click="jumpS(si)"
            >
              <div>1.{{ si + 1 }}</div>
              <div>{{ s.staTitle }}</div>
            </div>
            <div class="navBTitle" @click="jump('fouth')">3、项目活动过程</div>
            <div
              class="navLTitle"
              v-for="(sa, sib) in anliBox[0].process.stageBox"
              :key="sib"
              @click="jumpB(sib)"
            >
              <div>1.{{ sib + 1 }}</div>
              <div>活动阶段{{ sib + 1 }}</div>
            </div>
            <div class="navBTitle" @click="jump('fivth')">
              4、项目成果交流与评价
            </div>
            <div class="navBTitle" @click="jump('sixth')">
              5、项目成效与反思
            </div>
          </div>
        </div>
        <div v-if="isShow == 0">
          <div
            class="jdTopBox"
            id="first"
            style="padding: 20px 0 10px 0px"
            v-if="
              anliBox[0].info.courseText != '' ||
              anliBox[0].info.imgBox.length > 0 ||
              (anliBox &&
                anliBox[0].info &&
                anliBox[0].info.data &&
                anliBox[0].info.data.length)
            "
          >
            <div class="jdTopNav">
              <div class="navBg" style="font-size: 18px">基础信息</div>
            </div>
          </div>
          <div
            class="proOverCss"
            v-if="
              anliBox[0].info.courseText != '' ||
              anliBox[0].info.imgBox.length > 0 ||
              (anliBox &&
                anliBox[0].info &&
                anliBox[0].info.data &&
                anliBox[0].info.data.length)
            "
          >
            <div class="whiteBg whiteLeft">
              <div class="navBgTop">
                <div class="jdLeftNav">
                  <div class="jdImg">
                    <img
                      src="../../../../assets/icon/anliDetail/jdTitle.png"
                      alt=""
                    />
                  </div>
                  <div class="jdLeftTitle">
                    <div>项目简介</div>
                  </div>
                </div>

                <el-button
                  @click="selectNav(anliBox[0].info.courseText)"
                  v-if="selectHeight('poDetail')"
                  >查看更多</el-button
                >
              </div>
              <div
                v-if="
                  anliBox[0].info.courseText != '' ||
                  anliBox[0].info.imgBox.length > 0
                "
                class="imgAndNav"
                style="padding: 0 0 20px 0"
              >
                <!-- <div
                class="leftBox"
                v-if="
                  anliBox[0].info.imgBox.length > 0 &&
                  anliBox[0].info.imgBox[0].type == 3
                "
              >
                <div
                  class="leftImg"
                  @click="
                    lookFile1(
                      anliBox[0].info.imgBox[0].url,
                      anliBox[0].info.imgBox[0].type
                    )
                  "
                  v-if="anliBox[0].info.imgBox[0].type == 3"
                >
                  <img :src="anliBox[0].info.imgBox[0].url" alt="" />
                </div>
              </div> -->
                <!-- :class="
                  anliBox[0].info.imgBox.length > 0 ? 'proOverNav' : 'noImg'
                " -->
                <div
                  class="proOverNav"
                  v-html="anliBox[0].info ? anliBox[0].info.courseText : ''"
                  style="padding: 10px"
                  id="poDetail"
                ></div>
              </div>
              <div class="noFile" v-else>
                <img
                  src="../../../../assets/icon/anliDetail/noFile.jpg"
                  alt=""
                />
              </div>
            </div>
            <div
              class="whiteBg whiteLeft"
              style="min-height: 200px; margin-top: 5px"
            >
              <div
                class="jdLeftNav"
                style="margin: 0 0px 0px 15px; color: rgb(112, 112, 120)"
              >
                <div class="jdImg">
                  <img
                    src="../../../../assets/icon/anliDetail/jdTitle.png"
                    alt=""
                  />
                </div>
                <div class="jdLeftTitle">
                  <div>项目方案与活动案例</div>
                </div>
              </div>
              <!-- <div
                  style="margin: 33px 0px 0px 15px; color: rgb(112, 112, 120)"
                >
                  项目方案与活动案例：
                </div> -->
              <div class="fileBox" style="width: 97.5%; margin: 10px auto">
                <div
                  class="fileList"
                  :class="{
                    isVfileList: pptImgUrl2.infoData.showType == 3,
                  }"
                  v-if="
                    anliBox &&
                    anliBox[0].info &&
                    anliBox[0].info.data &&
                    anliBox[0].info.data.length
                  "
                  style="max-height: 150px; height: auto"
                >
                  <div
                    class="file"
                    v-for="(f, fIndex) in anliBox[0].info.data"
                    :key="fIndex"
                  >
                    <div class="fileCss">
                      <div>
                        {{ fIndex + 1 }}.{{
                          f.type == 1 ? "文档" : f.type == 2 ? "视频" : "图片"
                        }}
                      </div>
                      <div>
                        <el-tooltip
                          effect="light"
                          :content="f.name"
                          placement="top"
                        >
                          <div
                            :class="{
                              openTaskActive:
                                pptImgUrl1.fileType.infoType ==
                                pptImgUrl1.infoData[fIndex].id,
                            }"
                            @click="lookFile2(f.url, f.type, 0, '', fIndex)"
                          >
                            {{ f.name }}
                          </div>
                        </el-tooltip>
                        <div class="downFile" @click="downloadFile(f.url)">
                          <img
                            src="../../../../assets/icon/anliDetail/down.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="noFile" v-else>
                  <img
                    src="../../../../assets/icon/anliDetail/noFile.jpg"
                    alt=""
                  />
                </div>
              </div>
              <div style="margin: 5px 0 5px 25px; color: rgb(112, 112, 120)">
                预览模式：
              </div>
              <div
                class="fileLook"
                style="width: 96%"
                v-if="
                  pptImgUrl2.infoData != undefined &&
                  Object.keys(pptImgUrl2.infoData).length
                "
              >
                <div class="whiteRight">
                  <div class="fileTopAll">
                    <div class="fileTop">
                      <div class="fileListImg">
                        <img
                          src="../../../../assets/icon/anliDetail/onePic.png"
                          alt=""
                        />
                      </div>
                      <div>{{ pptImgUrl1.infoData[nameIndex].name }}</div>
                    </div>
                    <el-button @click="lookFile1(pptImgUrl2.infoData.url)"
                      >全屏查看</el-button
                    >
                  </div>
                  <div class="upCss">
                    <div
                      class="look_file"
                      style="width: 100%; margin: 10px 5px"
                    >
                      <pdf
                        v-if="pptImgUrl2.infoData.showType == 1"
                        :pdfUrl="pptImgUrl2.infoData.url"
                        style="width: 100%; height: 800px; overflow: auto"
                        :class="{ fullStyle: full }"
                      ></pdf>
                      <div v-if="pptImgUrl2.infoData.showType == 5"></div>
                      <!-- <vword
                          v-else-if="pptImgUrl2.infoData.showType == 2"
                          :pdfUrl="pptImgUrl2.infoData.url"
                          frameborder="0"
                          width="100%"
                          height="800"
                          :class="{ fullStyle: full }"
                        ></vword>
                        <div
                          class="workd_media"
                          style="height: 400px"
                          v-else-if="pptImgUrl2.infoData.showType == 3"
                        >
                          <video-player
                            class="video-player vjs-custom-skin"
                            :playsinline="true"
                            :options="pptImgUrl2.infoData.playerO"
                            @play="onPlayerPlay($event)"
                            style="width: 100%; height: 400px; margin: 0 auto"
                          ></video-player>
                        </div>
                        <div
                          class="leftImg"
                          style="height: 800px"
                          v-else-if="pptImgUrl2.infoData.showType == 4"
                        >
                          <img :src="pptImgUrl2.infoData.url" alt="" />
                        </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isShow == 1">
          <div
            class="jdTopBox"
            id="second"
            style="padding: 20px 0 15px 0px"
            v-if="
              (anliBox[0].overview.driQuestion.brief != '' ||
                anliBox[0].overview.driQuestion.imgBox.length > 0 ||
                anliBox[0].overview.driQuestion.data.length) &&
              (anliBox[0].overview.tarDesign.brief != '' ||
                anliBox[0].overview.tarDesign.imgBox.length > 0 ||
                anliBox[0].overview.tarDesign.data.length) &&
              (anliBox[0].overview.actiDesign.brief != '' ||
                anliBox[0].overview.actiDesign.imgBox.length > 0 ||
                anliBox[0].overview.actiDesign.data.length > 0)
            "
          >
            <div class="jdTopNav">
              <div class="navBg" style="font-size: 18px">项目概况</div>
            </div>
          </div>
          <div
            class="proOverCss"
            v-if="
              anliBox[0].overview.driQuestion.brief != '' ||
              anliBox[0].overview.driQuestion.imgBox.length > 0 ||
              anliBox[0].overview.driQuestion.data.length
            "
          >
            <div class="whiteBg whiteLeft">
              <div class="navBgTop">
                <div class="jdLeftNav">
                  <div class="jdImg">
                    <img
                      src="../../../../assets/icon/anliDetail/jdTitle.png"
                      alt=""
                    />
                  </div>
                  <div class="jdLeftTitle">
                    <div>驱动问题</div>
                  </div>
                </div>
                <el-button
                  v-if="selectHeight('poFirst')"
                  @click="selectNav(anliBox[0].overview.driQuestion.brief)"
                  >查看更多</el-button
                >
              </div>
              <div
                v-if="
                  anliBox[0].overview.driQuestion.brief != '' ||
                  anliBox[0].overview.driQuestion.imgBox.length > 0
                "
                class="imgAndNav"
              >
                <!-- <div
                  class="leftBox"
                  v-if="
                    anliBox[0].overview.driQuestion.imgBox.length > 0 &&
                    anliBox[0].overview.driQuestion.imgBox[0].type == 3
                  "
                >
                  <div
                    class="leftImg"
                    @click="
                      lookFile1(
                        anliBox[0].overview.driQuestion.imgBox[0].url,
                        anliBox[0].overview.driQuestion.imgBox[0].type
                      )
                    "
                    v-if="anliBox[0].overview.driQuestion.imgBox[0].type == 3"
                  >
                    <img
                      :src="anliBox[0].overview.driQuestion.imgBox[0].url"
                      alt=""
                    />
                  </div>
                </div> -->

                <div
                  class="proOverNav"
                  v-html="
                    anliBox[0].overview.driQuestion
                      ? anliBox[0].overview.driQuestion.brief
                      : ''
                  "
                  style="padding: 10px"
                  id="poFirst"
                ></div>
                <div
                  class="fileLook"
                  v-if="
                    pptImgUrl2.overData.driData != undefined &&
                    Object.keys(pptImgUrl2.overData.driData).length
                  "
                >
                  <div class="whiteRight">
                    <div class="fileTopAll">
                      <div class="fileTop">
                        <div class="fileListImg">
                          <img
                            src="../../../../assets/icon/anliDetail/fileList.png"
                            alt=""
                          />
                        </div>
                        <div>项⽬材料</div>
                      </div>
                      <el-button
                        @click="lookFile1(pptImgUrl2.overData.driData.url)"
                        >全屏查看</el-button
                      >
                    </div>
                    <div class="upCss">
                      <div class="look_file">
                        <pdf
                          v-if="pptImgUrl2.overData.driData.showType == 1"
                          :pdfUrl="pptImgUrl2.overData.driData.url"
                          style="width: 100%; height: 800px; overflow: auto"
                          :class="{ fullStyle: full }"
                        ></pdf>
                        <vword
                          v-else-if="pptImgUrl2.overData.driData.showType == 2"
                          :pdfUrl="pptImgUrl2.overData.driData.url"
                          frameborder="0"
                          width="100%"
                          height="800"
                          :class="{ fullStyle: full }"
                        ></vword>
                        <div
                          class="workd_media"
                          style="height: 400px"
                          v-else-if="pptImgUrl2.overData.driData.showType == 3"
                        >
                          <video-player
                            class="video-player vjs-custom-skin"
                            :playsinline="true"
                            :options="pptImgUrl2.overData.driData.playerO"
                            @play="onPlayerPlay($event)"
                            style="width: 100%; height: 400px; margin: 0 auto"
                          ></video-player>
                        </div>
                        <div
                          class="leftImg"
                          style="height: 800px"
                          v-else-if="pptImgUrl2.overData.driData.showType == 4"
                        >
                          <img :src="pptImgUrl2.overData.driData.url" alt="" />
                        </div>
                      </div>
                      <div class="fileBox">
                        <div
                          class="fileList"
                          v-if="anliBox[0].overview.driQuestion.data.length"
                          :class="{
                            isVfileList:
                              pptImgUrl2.overData.driData.showType == 3,
                          }"
                        >
                          <div
                            class="file"
                            v-for="(f, fIndex) in anliBox[0].overview
                              .driQuestion.data"
                            :key="fIndex"
                          >
                            <div class="fileCss">
                              <div>
                                {{ fIndex + 1 }}.{{
                                  f.type == 1
                                    ? "文档"
                                    : f.type == 2
                                    ? "视频"
                                    : "图片"
                                }}
                              </div>
                              <div>
                                <el-tooltip
                                  effect="light"
                                  :content="f.name"
                                  placement="top"
                                >
                                  <div
                                    :class="{
                                      openTaskActive:
                                        pptImgUrl1.fileType.overType.driType ==
                                        pptImgUrl1.overData.driData[fIndex].id,
                                    }"
                                    @click="
                                      lookFile2(f.url, f.type, 1, '', fIndex)
                                    "
                                  >
                                    {{ f.name }}
                                  </div>
                                </el-tooltip>
                                <div
                                  class="downFile"
                                  @click="downloadFile(f.url)"
                                >
                                  <img
                                    src="../../../../assets/icon/anliDetail/down.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="noFile" v-else>
                          <img
                            src="../../../../assets/icon/anliDetail/noFile.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="noFile" v-else>
                <img
                  src="../../../../assets/icon/anliDetail/noFile.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="proOverCss"
            id="xx"
            v-if="
              anliBox[0].overview.tarDesign.brief != '' ||
              anliBox[0].overview.tarDesign.imgBox.length > 0 ||
              anliBox[0].overview.tarDesign.data.length
            "
            style="margin-top: 5px"
          >
            <div class="whiteBg whiteLeft">
              <div class="navBgTop">
                <div class="jdLeftNav">
                  <div class="jdImg">
                    <img
                      src="../../../../assets/icon/anliDetail/jdTitle.png"
                      alt=""
                    />
                  </div>
                  <div class="jdLeftTitle">
                    <div>学习目标</div>
                  </div>
                </div>
                <el-button
                  v-if="selectHeight('poStudy')"
                  @click="selectNav(anliBox[0].overview.tarDesign.brief)"
                  >查看更多</el-button
                >
              </div>
              <div
                v-if="
                  anliBox[0].overview.tarDesign.brief != '' ||
                  anliBox[0].overview.tarDesign.imgBox.length > 0
                "
                class="imgAndNav"
              >
                <!-- <div
                  class="leftBox"
                  v-if="
                    anliBox[0].overview.tarDesign.imgBox.length > 0 &&
                    anliBox[0].overview.tarDesign.imgBox[0].type == 3
                  "
                >
                  <div
                    class="leftImg"
                    @click="
                      lookFile1(
                        anliBox[0].overview.tarDesign.imgBox[0].url,
                        anliBox[0].overview.tarDesign.imgBox[0].type
                      )
                    "
                    v-if="anliBox[0].overview.tarDesign.imgBox[0].type == 3"
                  >
                    <img
                      :src="anliBox[0].overview.tarDesign.imgBox[0].url"
                      alt=""
                    />
                  </div>
                </div> -->

                <div
                  class="proOverNav"
                  v-html="
                    anliBox[0].overview.tarDesign
                      ? anliBox[0].overview.tarDesign.brief
                      : ''
                  "
                  style="padding: 10px"
                  id="poStudy"
                ></div>
                <div
                  class="fileLook"
                  v-if="
                    pptImgUrl2.overData.tarData != undefined &&
                    Object.keys(pptImgUrl2.overData.tarData).length
                  "
                >
                  <div class="whiteRight">
                    <div class="fileTopAll">
                      <div class="fileTop">
                        <div class="fileListImg">
                          <img
                            src="../../../../assets/icon/anliDetail/fileList.png"
                            alt=""
                          />
                        </div>
                        <div>项⽬材料</div>
                      </div>
                      <el-button
                        @click="lookFile1(pptImgUrl2.overData.tarData.url)"
                        >全屏查看</el-button
                      >
                    </div>

                    <div class="upCss">
                      <div class="look_file">
                        <pdf
                          v-if="pptImgUrl2.overData.tarData.showType == 1"
                          :pdfUrl="pptImgUrl2.overData.tarData.url"
                          style="width: 100%; height: 800px; overflow: auto"
                          :class="{ fullStyle: full }"
                        ></pdf>
                        <vword
                          v-else-if="pptImgUrl2.overData.tarData.showType == 2"
                          :pdfUrl="pptImgUrl2.overData.tarData.url"
                          frameborder="0"
                          width="100%"
                          height="800"
                          :class="{ fullStyle: full }"
                        ></vword>
                        <div
                          class="workd_media"
                          style="height: 400px"
                          v-else-if="pptImgUrl2.overData.tarData.showType == 3"
                        >
                          <video-player
                            class="video-player vjs-custom-skin"
                            :playsinline="true"
                            :options="pptImgUrl2.overData.tarData.playerO"
                            @play="onPlayerPlay($event)"
                            style="width: 100%; height: 400px; margin: 0 auto"
                          ></video-player>
                        </div>
                        <div
                          class="leftImg"
                          style="height: 800px"
                          v-else-if="pptImgUrl2.overData.tarData.showType == 4"
                        >
                          <img :src="pptImgUrl2.overData.tarData.url" alt="" />
                        </div>
                      </div>
                      <div class="fileBox">
                        <div
                          class="fileList"
                          v-if="anliBox[0].overview.tarDesign.data.length"
                          :class="{
                            isVfileList:
                              pptImgUrl2.overData.tarData.showType == 3,
                          }"
                        >
                          <div
                            class="file"
                            v-for="(f, fIndex) in anliBox[0].overview.tarDesign
                              .data"
                            :key="fIndex"
                          >
                            <div class="fileCss">
                              <div>
                                {{ fIndex + 1 }}.{{
                                  f.type == 1
                                    ? "文档"
                                    : f.type == 2
                                    ? "视频"
                                    : "图片"
                                }}
                              </div>
                              <div>
                                <el-tooltip
                                  effect="light"
                                  :content="f.name"
                                  placement="top"
                                >
                                  <div
                                    :class="{
                                      openTaskActive:
                                        pptImgUrl1.fileType.overType.tarType ==
                                        pptImgUrl1.overData.tarData[fIndex].id,
                                    }"
                                    @click="
                                      lookFile2(f.url, f.type, 2, '', fIndex)
                                    "
                                  >
                                    {{ f.name }}
                                  </div>
                                </el-tooltip>
                                <div
                                  class="downFile"
                                  @click="downloadFile(f.url)"
                                >
                                  <img
                                    src="../../../../assets/icon/anliDetail/down.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="noFile" v-else>
                          <img
                            src="../../../../assets/icon/anliDetail/noFile.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="noFile" v-else>
                <img
                  src="../../../../assets/icon/anliDetail/noFile.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="proOverCss"
            id="pj"
            v-if="
              anliBox[0].overview.actiDesign.brief != '' ||
              anliBox[0].overview.actiDesign.imgBox.length > 0 ||
              anliBox[0].overview.actiDesign.data.length
            "
            style="margin-top: 5px"
          >
            <div class="whiteBg whiteLeft">
              <div class="navBgTop">
                <div class="jdLeftNav">
                  <div class="jdImg">
                    <img
                      src="../../../../assets/icon/anliDetail/jdTitle.png"
                      alt=""
                    />
                  </div>
                  <div class="jdLeftTitle">
                    <div>评价设计</div>
                  </div>
                </div>
                <el-button
                  v-if="selectHeight('proEva')"
                  @click="selectNav(anliBox[0].overview.actiDesign.brief)"
                  >查看更多</el-button
                >
              </div>
              <div
                v-if="
                  anliBox[0].overview.actiDesign.brief != '' ||
                  anliBox[0].overview.actiDesign.imgBox.length > 0
                "
                class="imgAndNav"
              >
                <!-- <div
                  class="leftBox"
                  v-if="
                    anliBox[0].overview.actiDesign.imgBox.length > 0 &&
                    anliBox[0].overview.actiDesign.imgBox[0].type == 3
                  "
                >
                  <div
                    class="leftImg"
                    @click="
                      lookFile1(
                        anliBox[0].overview.actiDesign.imgBox[0].url,
                        anliBox[0].overview.actiDesign.imgBox[0].type
                      )
                    "
                    v-if="anliBox[0].overview.actiDesign.imgBox[0].type == 3"
                  >
                    <img
                      :src="anliBox[0].overview.actiDesign.imgBox[0].url"
                      alt=""
                    />
                  </div>
                </div> -->

                <div
                  class="proOverNav"
                  v-html="
                    anliBox[0].overview.actiDesign
                      ? anliBox[0].overview.actiDesign.brief
                      : ''
                  "
                  style="padding: 10px"
                  id="proEva"
                ></div>
                <div
                  class="fileLook"
                  v-if="
                    pptImgUrl2.overData.actData != undefined &&
                    Object.keys(pptImgUrl2.overData.actData).length
                  "
                >
                  <div class="whiteRight">
                    <div class="fileTopAll">
                      <div class="fileTop">
                        <div class="fileListImg">
                          <img
                            src="../../../../assets/icon/anliDetail/fileList.png"
                            alt=""
                          />
                        </div>
                        <div>项⽬材料</div>
                      </div>
                      <el-button
                        @click="lookFile1(pptImgUrl2.overData.actData.url)"
                        >全屏查看</el-button
                      >
                    </div>
                    <div class="upCss">
                      <div class="look_file">
                        <pdf
                          v-if="pptImgUrl2.overData.actData.showType == 1"
                          :pdfUrl="pptImgUrl2.overData.actData.url"
                          style="width: 100%; height: 800px; overflow: auto"
                          :class="{ fullStyle: full }"
                        ></pdf>
                        <vword
                          v-else-if="pptImgUrl2.overData.actData.showType == 2"
                          :pdfUrl="pptImgUrl2.overData.actData.url"
                          frameborder="0"
                          width="100%"
                          height="800"
                          :class="{ fullStyle: full }"
                        ></vword>
                        <div
                          class="workd_media"
                          style="height: 400px"
                          v-else-if="pptImgUrl2.overData.actData.showType == 3"
                        >
                          <video-player
                            class="video-player vjs-custom-skin"
                            :playsinline="true"
                            :options="pptImgUrl2.overData.actData.playerO"
                            @play="onPlayerPlay($event)"
                            style="width: 100%; height: 400px; margin: 0 auto"
                          ></video-player>
                        </div>
                        <div
                          class="leftImg"
                          style="height: 800px"
                          v-else-if="pptImgUrl2.overData.actData.showType == 4"
                        >
                          <img :src="pptImgUrl2.overData.actData.url" alt="" />
                        </div>
                      </div>
                      <div class="fileBox">
                        <div
                          class="fileList"
                          v-if="anliBox[0].overview.actiDesign.data.length"
                          :class="{
                            isVfileList:
                              pptImgUrl2.overData.actData.showType == 3,
                          }"
                        >
                          <div
                            class="file"
                            v-for="(f, fIndex) in anliBox[0].overview.actiDesign
                              .data"
                            :key="fIndex"
                          >
                            <div class="fileCss">
                              <div>
                                {{ fIndex + 1 }}.{{
                                  f.type == 1
                                    ? "文档"
                                    : f.type == 2
                                    ? "视频"
                                    : "图片"
                                }}
                              </div>
                              <div>
                                <el-tooltip
                                  effect="light"
                                  :content="f.name"
                                  placement="top"
                                >
                                  <div
                                    :class="{
                                      openTaskActive:
                                        pptImgUrl1.fileType.overType.actType ==
                                        pptImgUrl1.overData.actData[fIndex].id,
                                    }"
                                    @click="
                                      lookFile2(f.url, f.type, 3, '', fIndex)
                                    "
                                  >
                                    {{ f.name }}
                                  </div>
                                </el-tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="noFile" v-else>
                          <img
                            src="../../../../assets/icon/anliDetail/noFile.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="noFile" v-else>
                <img
                  src="../../../../assets/icon/anliDetail/noFile.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div
            class="jdTopBox"
            v-if="anliBox[0].process.stageBox[0].staTitle != ''"
            id="third"
            style="padding: 20px 0 15px 0px; margin: 20px 0 0 0"
          >
            <div class="jdTopNav">
              <div class="jdNavBg">项目安排</div>
            </div>
          </div>
          <div
            v-for="(jd, jdIndex) in anliBox[0].process.stageBox"
            :key="jdIndex"
            class="jdChildCss"
          >
            <div class="jdBox">
              <div
                class="jdTopBox"
                v-if="jd.staTitle != ''"
                :id="'jd' + jdIndex"
                style="padding: 0 11px 10px 10px; margin: 0"
              >
                <div class="jdTopNav">
                  <div class="jdLeftNav">
                    <div
                      class="jdImg"
                      style="width: 25px; height: 25px; padding-left: 3px"
                    >
                      <img
                        src="../../../../assets/icon/anliDetail/jdNewTitle.png"
                        alt=""
                      />
                    </div>
                    <div class="jdLeftTitle">
                      <div>阶段{{ jdIndex + 1 }}</div>
                      <div>{{ jd.staTitle }}</div>
                    </div>
                  </div>
                  <div class="jdRightNav" v-if="jd.allTime">
                    {{ jd.allTime }}课时
                  </div>
                  <div class="funBlock" style="padding: 0">
                    <div
                      class="fold"
                      @click="fold1(jdIndex, $event, 1)"
                      v-if="jd.isFold == 0"
                    >
                      <!-- <div>折叠</div> -->
                      <el-button>折叠</el-button>
                    </div>
                    <div
                      class="fold"
                      @click="fold1(jdIndex, $event, 0)"
                      v-if="jd.isFold == 1"
                    >
                      <!-- <div>展开</div> -->
                      <el-button>展开</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-for="(hd, hdIndex) in jd.actBox" :key="hdIndex">
                <div
                  class="jdTopBox"
                  style="
                    padding: 5px 0px 15px;
                    border-bottom: 1px solid #e5e5e5;
                    border-radius: 0px;
                    margin: 0px auto;
                    width: 98%;
                  "
                  v-if="hd.actName != ''"
                >
                  <div class="jdTopNav">
                    <div class="jdLeftNav">
                      <div class="jdImg">
                        <img
                          src="../../../../assets/icon/anliDetail/rwTitle.png"
                          alt=""
                        />
                      </div>
                      <div class="jdLeftTitle">
                        <div>任务{{ hdIndex + 1 }}</div>
                        <div>{{ hd.actName }}</div>
                      </div>
                    </div>
                    <div class="jdRightNav" v-if="hd.actTime">
                      {{ hd.actTime }}课时
                    </div>
                    <!-- <div class="funBlock" style="padding: 0">
                    <div
                      class="fold"
                      @click="fold(hdIndex, jdIndex, $event, 1)"
                      v-if="hd.isFold == 0"
                    >
                      <div>折叠</div>
                    </div>
                    <div
                      class="fold"
                      @click="fold(hdIndex, jdIndex, $event, 0)"
                      v-if="hd.isFold == 1"
                    >
                      <div>展开</div>
                    </div>
                  </div> -->
                  </div>
                </div>
                <div
                  class="proOverCss"
                  v-if="
                    (hd.driQuestion.imgBox.length > 0 &&
                      hd.driQuestion.imgBox[0].type == 3) ||
                    hd.driQuestion.data.length
                  "
                  style="margin: 0"
                >
                  <div class="whiteBg whiteLeft">
                    <div class="navBgTop">
                      <div class="jdLeftNav">
                        <div class="jdImg">
                          <img
                            src="../../../../assets/icon/anliDetail/jdTitle.png"
                            alt=""
                          />
                        </div>
                        <div class="jdLeftTitle">
                          <div>活动目标</div>
                        </div>
                      </div>
                      <el-button
                        v-if="selectHeight('poAObj' + hdIndex)"
                        @click="selectNav(hd.driQuestion.brief)"
                        >查看更多</el-button
                      >
                    </div>
                    <div
                      v-if="
                        hd.driQuestion.brief != '' ||
                        hd.driQuestion.imgBox.length > 0
                      "
                      class="imgAndNav"
                    >
                      <!-- <div
                      class="leftBox"
                      style="padding: 10px 0 0 35px"
                      v-if="
                        hd.driQuestion.imgBox.length > 0 &&
                        hd.driQuestion.imgBox[0].type == 3
                      "
                    >
                      <div
                        class="leftImg"
                        @click="
                          lookFile1(
                            hd.driQuestion.imgBox[0].url,
                            hd.driQuestion.imgBox[0].type
                          )
                        "
                        v-if="hd.driQuestion.imgBox[0].type == 3"
                      >
                        <img :src="hd.driQuestion.imgBox[0].url" alt="" />
                      </div>
                    </div> -->

                      <div
                        class="proOverNav"
                        v-html="hd.driQuestion ? hd.driQuestion.brief : ''"
                        :id="'poAObj' + hdIndex"
                      ></div>
                    </div>
                    <div class="noFile" v-else>
                      <img
                        src="../../../../assets/icon/anliDetail/noFile.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="proOverCss"
                  v-if="
                    hd.tarDesign.brief != '' ||
                    hd.tarDesign.imgBox.length > 0 ||
                    hd.tarDesign.data.length
                  "
                >
                  <div class="whiteBg whiteLeft">
                    <div class="navBgTop">
                      <div class="jdLeftNav">
                        <div class="jdImg">
                          <img
                            src="../../../../assets/icon/anliDetail/jdTitle.png"
                            alt=""
                          />
                        </div>
                        <div class="jdLeftTitle">
                          <div>活动内容</div>
                        </div>
                      </div>
                      <el-button
                        v-if="selectHeight('poACon' + hdIndex)"
                        @click="selectNav(hd.tarDesign.brief)"
                        >查看更多</el-button
                      >
                    </div>
                    <div
                      v-if="
                        hd.tarDesign.brief != '' ||
                        hd.tarDesign.imgBox.length > 0
                      "
                      class="imgAndNav"
                    >
                      <!-- <div
                      class="leftBox"
                      style="padding: 10px 0 0 35px"
                      v-if="
                        hd.tarDesign.imgBox.length > 0 &&
                        hd.tarDesign.imgBox[0].type == 3
                      "
                    >
                      <div
                        class="leftImg"
                        @click="
                          lookFile1(
                            hd.tarDesign.imgBox[0].url,
                            hd.tarDesign.imgBox[0].type
                          )
                        "
                        v-if="hd.tarDesign.imgBox[0].type == 3"
                      >
                        <img :src="hd.tarDesign.imgBox[0].url" alt="" />
                      </div>
                    </div> -->

                      <div
                        class="proOverNav"
                        v-html="hd.tarDesign ? hd.tarDesign.brief : ''"
                        :id="'poACon' + hdIndex"
                      ></div>
                    </div>
                    <div class="noFile" v-else>
                      <img
                        src="../../../../assets/icon/anliDetail/noFile.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="proOverCss"
                  v-if="
                    hd.actiDesign.brief != '' ||
                    hd.actiDesign.imgBox.length > 0 ||
                    hd.actiDesign.data.length
                  "
                >
                  <div class="whiteBg whiteLeft">
                    <div class="navBgTop">
                      <div class="jdLeftNav">
                        <div class="jdImg">
                          <img
                            src="../../../../assets/icon/anliDetail/jdTitle.png"
                            alt=""
                          />
                        </div>
                        <div class="jdLeftTitle">
                          <div>预期成果</div>
                        </div>
                      </div>
                      <el-button
                        v-if="selectHeight('poExp' + hdIndex)"
                        @click="selectNav(hd.actiDesign.brief)"
                        >查看更多</el-button
                      >
                    </div>
                    <div
                      v-if="
                        hd.actiDesign.brief != '' ||
                        hd.actiDesign.imgBox.length > 0
                      "
                      class="imgAndNav"
                    >
                      <!-- <div
                      class="leftBox"
                      style="padding: 10px 0 0 35px"
                      v-if="
                        hd.actiDesign.imgBox.length > 0 &&
                        hd.actiDesign.imgBox[0].type == 3
                      "
                    >
                      <div
                        class="leftImg"
                        @click="
                          lookFile1(
                            hd.actiDesign.imgBox[0].url,
                            hd.actiDesign.imgBox[0].type
                          )
                        "
                        v-if="hd.actiDesign.imgBox[0].type == 3"
                      >
                        <img :src="hd.actiDesign.imgBox[0].url" alt="" />
                      </div>
                    </div> -->

                      <div
                        class="proOverNav"
                        v-html="hd.actiDesign ? hd.actiDesign.brief : ''"
                        :id="'poExp' + hdIndex"
                      ></div>
                    </div>
                    <div class="noFile" v-else>
                      <img
                        src="../../../../assets/icon/anliDetail/noFile.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="proOverCss"
                  v-if="
                    hd.evaDesign.brief != '' ||
                    hd.evaDesign.imgBox.length > 0 ||
                    hd.evaDesign.data.length
                  "
                  style="margin: 0"
                >
                  <div class="whiteBg whiteLeft">
                    <div class="navBgTop">
                      <div class="jdLeftNav">
                        <div class="jdImg">
                          <img
                            src="../../../../assets/icon/anliDetail/jdTitle.png"
                            alt=""
                          />
                        </div>
                        <div class="jdLeftTitle">
                          <div>活动评价</div>
                        </div>
                      </div>
                      <el-button
                        v-if="selectHeight('poAEva' + hdIndex)"
                        @click="selectNav(hd.evaDesign.brief)"
                        >查看更多</el-button
                      >
                    </div>
                    <div
                      v-if="
                        hd.evaDesign.brief != '' ||
                        hd.evaDesign.imgBox.length > 0
                      "
                      class="imgAndNav"
                    >
                      <!-- <div
                      class="leftBox"
                      style="padding: 10px 0 0 35px"
                      v-if="
                        hd.evaDesign.imgBox.length > 0 &&
                        hd.evaDesign.imgBox[0].type == 3
                      "
                    >
                      <div
                        class="leftImg"
                        @click="
                          lookFile1(
                            hd.evaDesign.imgBox[0].url,
                            hd.evaDesign.imgBox[0].type
                          )
                        "
                        v-if="hd.evaDesign.imgBox[0].type == 3"
                      >
                        <img :src="hd.evaDesign.imgBox[0].url" alt="" />
                      </div>
                    </div> -->

                      <div
                        class="proOverNav"
                        v-html="hd.evaDesign ? hd.evaDesign.brief : ''"
                        :id="'poAEva' + hdIndex"
                      ></div>
                    </div>
                    <div class="noFile" v-else>
                      <img
                        src="../../../../assets/icon/anliDetail/noFile.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="jdTopBox"
            id="fouth"
            v-if="anliBox[0].process.stageBox[0].brief != ''"
            style="padding: 20px 20px 15px 0px; margin: 20px 0 5px 0"
          >
            <div class="jdTopNav">
              <div class="bigNavBg" style="width: 155px">项目活动过程</div>
            </div>
          </div>
          <div
            v-for="(jd, jdIndex) in anliBox[0].process.stageBox"
            :key="jdIndex"
          >
            <div
              class="proOverCss"
              v-if="jd.brief != '' || jd.imgBox.length > 0 || jd.data.length"
              :id="'jdb' + jdIndex"
            >
              <div class="whiteBg whiteLeft">
                <div class="navBgTop">
                  <div class="jdLeftNav">
                    <div class="jdImg">
                      <img
                        src="../../../../assets/icon/anliDetail/jdTitle.png"
                        alt=""
                      />
                    </div>
                    <div class="jdLeftTitle">
                      <div>阶段{{ jdIndex + 1 }}</div>
                    </div>
                  </div>
                  <el-button
                    v-if="selectHeight('poAct' + jdIndex)"
                    @click="selectNav(jd.brief)"
                    >查看更多</el-button
                  >
                </div>
                <div
                  v-if="jd.brief != '' || jd.imgBox.length > 0"
                  class="imgAndNav"
                >
                  <!-- <div
                    class="leftBox"
                    v-if="jd.imgBox.length > 0 && jd.imgBox[0].type == 3"
                  >
                    <div
                      class="leftImg"
                      @click="lookFile1(jd.imgBox[0].url, jd.imgBox[0].type)"
                      v-if="jd.imgBox[0].type == 3"
                    >
                      <img :src="jd.imgBox[0].url" alt="" />
                    </div>
                  </div> -->

                  <div
                    class="proOverNav"
                    v-html="jd ? jd.brief : ''"
                    :id="'poAct' + jdIndex"
                  ></div>
                  <div class="fileLook" v-if="pptImgUrl2.proData[jdIndex]">
                    <div class="whiteRight">
                      <div class="fileTopAll">
                        <div class="fileTop">
                          <div class="fileListImg">
                            <img
                              src="../../../../assets/icon/anliDetail/fileList.png"
                              alt=""
                            />
                          </div>
                          <div>项⽬材料</div>
                        </div>
                        <el-button
                          @click="lookFile1(pptImgUrl2.proData[jdIndex].url)"
                          >全屏查看</el-button
                        >
                      </div>
                      <div class="upCss">
                        <div class="look_file">
                          <pdf
                            v-if="pptImgUrl2.proData[jdIndex].showType == 1"
                            :pdfUrl="pptImgUrl2.proData[jdIndex].url"
                            style="width: 100%; height: 800px; overflow: auto"
                            :class="{ fullStyle: full }"
                          ></pdf>
                          <vword
                            v-else-if="
                              pptImgUrl2.proData[jdIndex].showType == 2
                            "
                            :pdfUrl="pptImgUrl2.proData[jdIndex].url"
                            frameborder="0"
                            width="100%"
                            height="800"
                            :class="{ fullStyle: full }"
                          ></vword>
                          <div
                            class="workd_media"
                            style="height: 400px"
                            v-else-if="
                              pptImgUrl2.proData[jdIndex].showType == 3
                            "
                          >
                            <video-player
                              class="video-player vjs-custom-skin"
                              :playsinline="true"
                              :options="pptImgUrl2.proData[jdIndex].playerO"
                              @play="onPlayerPlay($event)"
                              style="width: 100%; height: 400px; margin: 0 auto"
                            ></video-player>
                          </div>
                          <div
                            class="leftImg"
                            style="height: 800px"
                            v-else-if="
                              pptImgUrl2.proData[jdIndex].showType == 4
                            "
                          >
                            <img
                              :src="pptImgUrl2.proData[jdIndex].url"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="fileBox">
                          <div
                            class="fileList"
                            v-if="jd.data.length"
                            :class="{
                              isVfileList:
                                pptImgUrl2.proData[jdIndex].showType == 3,
                            }"
                          >
                            <div
                              class="file"
                              v-for="(f, fIndex) in jd.data"
                              :key="fIndex"
                            >
                              <div class="fileCss">
                                <div>
                                  {{ fIndex + 1 }}.{{
                                    f.type == 1
                                      ? "文档"
                                      : f.type == 2
                                      ? "视频"
                                      : "图片"
                                  }}
                                </div>
                                <div>
                                  <el-tooltip
                                    effect="light"
                                    :content="f.name"
                                    placement="top"
                                  >
                                    <div
                                      :class="{
                                        openTaskActive:
                                          pptImgUrl1.fileType.proType ==
                                          pptImgUrl1.proData[jdIndex][fIndex]
                                            .id,
                                      }"
                                      @click="
                                        lookFile2(
                                          f.url,
                                          f.type,
                                          4,
                                          jdIndex,
                                          fIndex
                                        )
                                      "
                                    >
                                      {{ f.name }}
                                    </div>
                                  </el-tooltip>
                                  <div
                                    class="downFile"
                                    @click="downloadFile(f.url)"
                                  >
                                    <img
                                      src="../../../../assets/icon/anliDetail/down.png"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="noFile" v-else>
                            <img
                              src="../../../../assets/icon/anliDetail/noFile.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="noFile" v-else>
                  <img
                    src="../../../../assets/icon/anliDetail/noFile.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="jdTopBox"
            id="fivth"
            v-if="
              anliBox[0].proexc.brief != '' ||
              anliBox[0].proexc.imgBox.length > 0 ||
              anliBox[0].proexc.data.length
            "
            style="padding: 20px 20px 15px 0px; margin: 20px 0 5px 0"
          >
            <div class="jdTopNav">
              <div class="bigNavBg" style="width: 212px">
                项目成果交流与评价
              </div>
            </div>
          </div>
          <div
            class="proOverCss"
            v-if="
              anliBox[0].proexc.brief != '' ||
              anliBox[0].proexc.imgBox.length > 0 ||
              anliBox[0].proexc.data.length
            "
          >
            <div class="whiteBg whiteLeft">
              <div class="navBgTop">
                <div class="jdLeftNav">
                  <div class="jdImg">
                    <img
                      src="../../../../assets/icon/anliDetail/jdTitle.png"
                      alt=""
                    />
                  </div>
                  <div class="jdLeftTitle">
                    <div>活动成果</div>
                  </div>
                </div>
                <el-button
                  v-if="selectHeight('poAch')"
                  @click="selectNav(anliBox[0].proexc.brief)"
                  >查看更多</el-button
                >
              </div>
              <div
                v-if="
                  anliBox[0].proexc.brief != '' ||
                  anliBox[0].proexc.imgBox.length > 0
                "
                class="imgAndNav"
              >
                <!-- <div
                  class="leftBox"
                  v-if="
                    anliBox[0].proexc.imgBox.length > 0 &&
                    anliBox[0].proexc.imgBox[0].type == 3
                  "
                >
                  <div
                    class="leftImg"
                    @click="
                      lookFile1(
                        anliBox[0].proexc.imgBox[0].url,
                        anliBox[0].proexc.imgBox[0].type
                      )
                    "
                    v-if="anliBox[0].proexc.imgBox[0].type == 3"
                  >
                    <img :src="anliBox[0].proexc.imgBox[0].url" alt="" />
                  </div>
                </div> -->

                <div
                  class="proOverNav"
                  v-html="anliBox[0].proexc ? anliBox[0].proexc.brief : ''"
                  style="padding: 10px"
                  id="poAch"
                ></div>
                <div
                  class="fileLook"
                  v-if="
                    pptImgUrl2.excData != undefined &&
                    Object.keys(pptImgUrl2.excData).length
                  "
                >
                  <div class="whiteRight">
                    <div class="fileTopAll">
                      <div class="fileTop">
                        <div class="fileListImg">
                          <img
                            src="../../../../assets/icon/anliDetail/fileList.png"
                            alt=""
                          />
                        </div>
                        <div>项⽬材料</div>
                      </div>
                      <el-button @click="lookFile1(pptImgUrl2.excData.url)"
                        >全屏查看</el-button
                      >
                    </div>

                    <div class="upCss">
                      <div class="look_file">
                        <pdf
                          v-if="pptImgUrl2.excData.showType == 1"
                          :pdfUrl="pptImgUrl2.excData.url"
                          style="width: 100%; height: 800px; overflow: auto"
                          :class="{ fullStyle: full }"
                        ></pdf>
                        <vword
                          v-else-if="pptImgUrl2.excData.showType == 2"
                          :pdfUrl="pptImgUrl2.excData.url"
                          frameborder="0"
                          width="100%"
                          height="800"
                          :class="{ fullStyle: full }"
                        ></vword>
                        <div
                          class="workd_media"
                          style="height: 400px"
                          v-else-if="pptImgUrl2.excData.showType == 3"
                        >
                          <video-player
                            class="video-player vjs-custom-skin"
                            :playsinline="true"
                            :options="pptImgUrl2.excData.playerO"
                            @play="onPlayerPlay($event)"
                            style="width: 100%; height: 400px; margin: 0 auto"
                          ></video-player>
                        </div>
                        <div
                          class="leftImg"
                          style="height: 800px"
                          v-else-if="pptImgUrl2.excData.showType == 4"
                        >
                          <img :src="pptImgUrl2.excData.url" alt="" />
                        </div>
                      </div>
                      <div class="fileBox">
                        <div
                          class="fileList"
                          v-if="anliBox[0].proexc.data.length"
                          :class="{
                            isVfileList: pptImgUrl2.excData.showType == 3,
                          }"
                        >
                          <div
                            class="file"
                            v-for="(f, fIndex) in anliBox[0].proexc.data"
                            :key="fIndex"
                          >
                            <div class="fileCss">
                              <div>
                                {{ fIndex + 1 }}.{{
                                  f.type == 1
                                    ? "文档"
                                    : f.type == 2
                                    ? "视频"
                                    : "图片"
                                }}
                              </div>
                              <div>
                                <el-tooltip
                                  effect="light"
                                  :content="f.name"
                                  placement="top"
                                >
                                  <div
                                    :class="{
                                      openTaskActive:
                                        pptImgUrl1.fileType.excType ==
                                        pptImgUrl1.excData[fIndex].id,
                                    }"
                                    @click="
                                      lookFile2(f.url, f.type, 5, '', fIndex)
                                    "
                                  >
                                    {{ f.name }}
                                  </div>
                                </el-tooltip>
                                <div
                                  class="downFile"
                                  @click="downloadFile(f.url)"
                                >
                                  <img
                                    src="../../../../assets/icon/anliDetail/down.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="noFile" v-else>
                          <img
                            src="../../../../assets/icon/anliDetail/noFile.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="noFile" v-else>
                <img
                  src="../../../../assets/icon/anliDetail/noFile.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div
            class="jdTopBox"
            id="sixth"
            v-if="
              anliBox[0].results.brief != '' ||
              anliBox[0].results.imgBox.length > 0 ||
              anliBox[0].results.data.length
            "
            style="padding: 20px 20px 15px 0px; margin: 20px 0 5px 0"
          >
            <div class="jdTopNav">
              <div class="bigNavBg">项目成效与反思</div>
            </div>
          </div>
          <div
            class="proOverCss"
            v-if="
              anliBox[0].results.brief != '' ||
              anliBox[0].results.imgBox.length > 0 ||
              anliBox[0].results.data.length
            "
          >
            <div class="whiteBg whiteLeft">
              <div class="navBgTop">
                <div class="jdLeftNav">
                  <div class="jdImg">
                    <img
                      src="../../../../assets/icon/anliDetail/jdTitle.png"
                      alt=""
                    />
                  </div>
                  <div class="jdLeftTitle">
                    <div>活动反思</div>
                  </div>
                </div>
                <el-button
                  v-if="selectHeight('poRes')"
                  @click="selectNav(anliBox[0].results.brief)"
                  >查看更多</el-button
                >
              </div>
              <div
                v-if="
                  anliBox[0].results.brief != '' ||
                  anliBox[0].results.imgBox.length > 0
                "
                class="imgAndNav"
              >
                <!-- <div
                  class="leftBox"
                  v-if="
                    anliBox[0].results.imgBox.length > 0 &&
                    anliBox[0].results.imgBox[0].type == 3
                  "
                >
                  <div
                    class="leftImg"
                    @click="
                      lookFile1(
                        anliBox[0].results.imgBox[0].url,
                        anliBox[0].results.imgBox[0].type
                      )
                    "
                    v-if="anliBox[0].results.imgBox[0].type == 3"
                  >
                    <img :src="anliBox[0].results.imgBox[0].url" alt="" />
                  </div>
                </div> -->

                <div
                  class="proOverNav"
                  v-html="anliBox[0].results ? anliBox[0].results.brief : ''"
                  style="padding: 10px"
                  id="poRes"
                ></div>
                <div
                  class="fileLook"
                  v-if="
                    pptImgUrl2.effData != undefined &&
                    Object.keys(pptImgUrl2.effData).length
                  "
                >
                  <div class="whiteRight">
                    <div class="fileTopAll">
                      <div class="fileTop">
                        <div class="fileListImg">
                          <img
                            src="../../../../assets/icon/anliDetail/fileList.png"
                            alt=""
                          />
                        </div>
                        <div>项⽬材料</div>
                      </div>
                      <el-button @click="lookFile1(pptImgUrl2.effData.url)"
                        >全屏查看</el-button
                      >
                    </div>

                    <div class="upCss">
                      <div class="look_file">
                        <pdf
                          v-if="pptImgUrl2.effData.showType == 1"
                          :pdfUrl="pptImgUrl2.effData.url"
                          style="width: 100%; height: 800px; overflow: auto"
                          :class="{ fullStyle: full }"
                        ></pdf>
                        <vword
                          v-else-if="pptImgUrl2.effData.showType == 2"
                          :pdfUrl="pptImgUrl2.effData.url"
                          frameborder="0"
                          width="100%"
                          height="800"
                          :class="{ fullStyle: full }"
                        ></vword>
                        <div
                          class="workd_media"
                          style="height: 400px"
                          v-else-if="pptImgUrl2.effData.showType == 3"
                        >
                          <video-player
                            class="video-player vjs-custom-skin"
                            :playsinline="true"
                            :options="pptImgUrl2.effData.playerO"
                            @play="onPlayerPlay($event)"
                            style="width: 100%; height: 400px; margin: 0 auto"
                          ></video-player>
                        </div>
                        <div
                          class="leftImg"
                          style="height: 800px"
                          v-else-if="pptImgUrl2.effData.showType == 4"
                        >
                          <img :src="pptImgUrl2.effData.url" alt="" />
                        </div>
                      </div>
                      <div class="fileBox">
                        <div
                          class="fileList"
                          v-if="anliBox[0].results.data.length"
                          :class="{
                            isVfileList: pptImgUrl2.effData.showType == 3,
                          }"
                        >
                          <div
                            class="file"
                            v-for="(f, fIndex) in anliBox[0].results.data"
                            :key="fIndex"
                          >
                            <div class="fileCss">
                              <div>
                                {{ fIndex + 1 }}.{{
                                  f.type == 1
                                    ? "文档"
                                    : f.type == 2
                                    ? "视频"
                                    : "图片"
                                }}
                              </div>
                              <div>
                                <el-tooltip
                                  effect="light"
                                  :content="f.name"
                                  placement="top"
                                >
                                  <div
                                    :class="{
                                      openTaskActive:
                                        pptImgUrl1.fileType.effType ==
                                        pptImgUrl1.effData[fIndex].id,
                                    }"
                                    @click="
                                      lookFile2(f.url, f.type, 6, '', fIndex)
                                    "
                                  >
                                    {{ f.name }}
                                  </div>
                                </el-tooltip>
                                <div
                                  class="downFile"
                                  @click="downloadFile(f.url)"
                                >
                                  <img
                                    src="../../../../assets/icon/anliDetail/down.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="noFile" v-else>
                          <img
                            src="../../../../assets/icon/anliDetail/noFile.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="noFile" v-else>
                <img
                  src="../../../../assets/icon/anliDetail/noFile.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="fixBottom">
        <div class="returnAnLi" style="width: 100px" @click="goToX()">
          前往评分
        </div>
        <div class="returnAnLi" @click="returnWhere">返回</div>
      </div> -->

      <div class="returnTop" v-if="isNavTop >= 300" @click="reTop">
        回到顶部
      </div>
    </div>
    <el-dialog
      title="查看详情"
      :visible.sync="dialogVisibleBrief"
      :append-to-body="true"
      width="1000px"
      height="80%"
      :before-close="handleClose"
      class="add_student"
    >
      <div class="detailTable" v-html="briefNav"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBrief = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="文件预览"
      :visible.sync="dialogVisible"
      width="100%"
      :before-close="handleClose"
      class="dialog_diy"
      :class="{ fullStyle: full }"
    >
      <div slot="title" class="header-title">
        <div style="color: #fff">文件预览</div>
        <div style="position: absolute; top: 19px; right: 50px">
          <img
            src="../../../../assets/full.png"
            style="height: 16px; cursor: pointer"
            alt=""
            @click="fullTools"
          />
        </div>
      </div>
      <pdf
        v-if="showPDF"
        :pdfUrl="pptImgUrl"
        style="width: 100%; height: 100%; overflow: auto"
        :class="{ fullStyle: full }"
      ></pdf>
      <vword
        v-else
        :pdfUrl="pptImgUrl"
        frameborder="0"
        width="100%"
        height="800"
        :class="{ fullStyle: full }"
      ></vword>
    </el-dialog>
    <el-dialog
      title="查看视频"
      :visible.sync="videoVisible"
      :append-to-body="true"
      width="1000px"
      :before-close="handleClose"
      class="dialog_diy1"
    >
      <div class="workd_media" style="height: 100%" v-if="videoDetail.sources">
        <video-player
          class="video-player vjs-custom-skin"
          :playsinline="true"
          :options="videoDetail"
          @play="onPlayerPlay($event)"
          style="width: 100%; height: 100%"
        ></video-player>
      </div>
      <div slot="footer">
        <el-button
          style="background: #409efe; color: #fff"
          @click="(videoVisible = false), (videoDetail.sources[0].src = '')"
        >
          关 闭</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="评分"
      :visible.sync="dialogVisibleScore"
      :append-to-body="true"
      width="25%"
      height="80%"
      :before-close="handleClose"
      class="customWidth1"
    >
      <div class="scoreBox" v-for="(s, sIndex) in scoreDetail" :key="sIndex">
        <div class="scoreCss">
          <div class="scoreTitle">
            <div><img src="../../../../assets/avatar.png" alt="" /></div>
            <div>{{ s.uname }}</div>
          </div>
          <div class="anliTitle">
            <div>案例名称</div>
            <div>{{ s.title }}</div>
          </div>
          <div class="anliBrief">
            <div>案例简介</div>
            <div style="width: 650px; max-height: 150px; overflow: auto">
              {{ s.detail }}
            </div>
          </div>
          <div class="anliScore">
            <div>请选择评分</div>
            <div>
              <div class="scoreDiv">
                <div>项目式学习</div>
                <div>
                  <el-input
                    placeholder="输入分数"
                    v-model="s.scoreAll.first"
                    @change="isNumber($event, 1)"
                  ></el-input>
                </div>
              </div>
              <div class="scoreDiv">
                <div>项目成果</div>
                <div>
                  <el-input
                    placeholder="输入分数"
                    v-model="s.scoreAll.second"
                    @change="isNumber($event, 2)"
                  ></el-input>
                </div>
              </div>
              <div class="scoreDiv">
                <div>项目评价</div>
                <div>
                  <el-input
                    placeholder="输入分数"
                    v-model="s.scoreAll.third"
                    @change="isNumber($event, 3)"
                  ></el-input>
                </div>
              </div>
              <!-- <div class="scoreDiv">
                <div>评审维度4</div>
                <div>
                  <el-input
                    placeholder="输入分数"
                    v-model="s.scoreAll.fourth"
                    @change="isNumber($event, 4)"
                  ></el-input>
                </div>
              </div>
              <div class="scoreDiv">
                <div>评审维度5</div>
                <div>
                  <el-input
                    placeholder="输入分数"
                    v-model="s.scoreAll.fivth"
                    @change="isNumber($event, 5)"
                  ></el-input>
                </div>
              </div> -->
            </div>
          </div>
          <div class="anliContent">
            <textarea
              :rows="5"
              class="tAreaCss"
              placeholder="请输入评语。"
              v-model="s.scoreAll.content"
            ></textarea>
          </div>
          <div class="addScore" @click="addScore">进行评分</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pdf from "../../components/vpdf";
import vword from "../../components/vword";
export default {
  components: {
    pdf,
    vword,
  },
  data() {
    return {
      dialogVisibleBrief: false,
      dialogVisible: false,
      showPDF: false,
      showPDF1: false,
      videoVisible: false,
      full: false,
      dialogVisibleScore: false,
      briefNav: "",
      pptImgUrl: "",
      pptImgUrl1: {
        fileType: {
          infoType: "",
          overType: {
            driType: "",
            tarType: "",
            actType: "",
          },
          proType: "",
          excType: "",
          effType: "",
        },
        infoData: [],
        overData: {
          driData: [],
          tarData: [],
          actData: [],
        },
        proData: [],
        excData: [],
        effData: [],
      },
      pptImgUrl2: {
        infoData: {},
        overData: {
          driData: {},
          tarData: {},
          actData: {},
        },
        proData: {},
        excData: {},
        effData: {},
      },
      fileImg: "",
      userid: this.$store.state.userInfo.userid,
      oid: this.$store.state.userInfo.school,
      aid: this.$route.query.aid,
      anliBox: [],
      imgAnliBox: [],
      noBanner: require("../../../../assets/noBanner.jpg"),
      videoDetail: {},
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目   || "video/ogg"|| "video/webm"
            src: "", //url地址require("../../assets/media/aaa.mp4")
          },
        ],
        // poster: require("../../assets/tu31.png"), //你的封面地址
        // poster: dataRes.imgUrl, //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
      playerO: {},
      isNavTop: 0,
      isShow: 0,
      nameIndex: 0,
      scoreDetail: [
        {
          id: "",
          uname: "",
          title: "",
          detail: "",
          scoreAll: {
            first: "",
            second: "",
            third: "",
            // fourth: "",
            // fivth: "",
            content: "",
          },
          sumScore: 0,
        },
      ],
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    goTo(path) {
      this.$router.push(path);
    },
    goToX() {
      this.$message("暂未开放");
      return;
    },
    previewImg(url) {
      this.$hevueImgPreview(url);
    },
    fullTools() {
      this.full = !this.full;
    },
    // returnWhere() {
    //   if (this.type == 0) {
    //     this.goTo("/eventCenter?steps=" + "2");
    //   } else {
    //     this.goTo("/anliList");
    //   }
    // },
    isNumber(e, t) {
      if (e.includes(".")) {
        this.$message.error("暂时不支持小数点评分");
      }
      let value = /^\d+$/.test(e);
      // let value = e.replace(/[^d]/g, ""); // 只能输入数字
      if (value == true) {
        if (e < 0) {
          this.$message.error("请输入大于0的数值");
          if (t == 1) {
            this.scoreDetail[0].scoreAll.first = "";
          } else if (t == 2) {
            this.scoreDetail[0].scoreAll.second = "";
          } else {
            this.scoreDetail[0].scoreAll.third = "";
          }
          //  else if (t == 4) {
          //   this.scoreDetail[0].scoreAll.fourth = "";
          // } else {
          //   this.scoreDetail[0].scoreAll.fivth = "";
          // }
          return;
        } else if (e > 100) {
          this.$message.error("数值不能大于100");
          if (t == 1) {
            this.scoreDetail[0].scoreAll.first = "";
          } else if (t == 2) {
            this.scoreDetail[0].scoreAll.second = "";
          } else {
            this.scoreDetail[0].scoreAll.third = "";
          }
          //  else if (t == 4) {
          //   this.scoreDetail[0].scoreAll.fourth = "";
          // } else {
          //   this.scoreDetail[0].scoreAll.fivth = "";
          // }
          return;
        }
      } else {
        if (t == 1) {
          this.scoreDetail[0].scoreAll.first = "";
        } else if (t == 2) {
          this.scoreDetail[0].scoreAll.second = "";
        } else {
          this.scoreDetail[0].scoreAll.third = "";
        }
        //  else if (t == 4) {
        //   this.scoreDetail[0].scoreAll.fourth = "";
        // } else {
        //   this.scoreDetail[0].scoreAll.fivth = "";
        // }
        this.$message.error("请输入数字");
        return;
      }

      // value = value.replace(/^0+(d)/, "$1"); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      // value = value.replace(/(d{15})d*/, "$1"); // 最多保留15位整数
      // this.height = value;
    },
    openScore(a) {
      this.scoreDetail[0].id = a.id;
      this.scoreDetail[0].title = a.info.title;
      this.scoreDetail[0].detail = a.info.courseText;
      this.scoreDetail[0].uname = a.name;
      this.getScore(a.id);
    },
    getScore(id, t) {
      let params = {
        rid: id,
        suser: this.$store.state.userInfo.userid,
      };
      this.ajax
        .get(this.$store.state.api + "selectScore", params)
        .then((res) => {
          if (res.data[0].length > 0) {
            this.scoreDetail[0].scoreAll = JSON.parse(res.data[0][0].score);
            var a = parseInt(this.scoreDetail[0].scoreAll.first);
            var b = parseInt(this.scoreDetail[0].scoreAll.second);
            var c = parseInt(this.scoreDetail[0].scoreAll.third);
            // var d = parseInt(this.scoreDetail[0].scoreAll.fourth);
            // var e = parseInt(this.scoreDetail[0].scoreAll.fivth);
            // this.scoreDetail[0].sumScore = Math.round((a + b + c + d + e) / 5);
            this.scoreDetail[0].sumScore = Math.round((a + b + c) / 3);
          } else {
            this.scoreDetail[0].scoreAll = {
              first: "",
              second: "",
              third: "",
              // fourth: "",
              // fivth: "",
              content: "",
            };
            this.scoreDetail[0].sumScore = 0;
          }
          this.dialogVisibleScore = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    addScore() {
      if (this.scoreDetail[0].scoreAll.first == "") {
        this.$message.error("请将信息填写完整");
        return;
      } else if (this.scoreDetail[0].scoreAll.second == "") {
        this.$message.error("请将信息填写完整");
        return;
      } else if (this.scoreDetail[0].scoreAll.third == "") {
        this.$message.error("请将信息填写完整");
        return;
      }
      //  else if (this.scoreDetail[0].scoreAll.fourth == "") {
      //   this.$message.error("请将信息填写完整");
      //   return;
      // } else if (this.scoreDetail[0].scoreAll.fivth == "") {
      //   this.$message.error("请将信息填写完整");
      //   return;
      // }
      let params = [
        {
          rid: this.scoreDetail[0].id,
          suser: this.$store.state.userInfo.userid,
          s: JSON.stringify(this.scoreDetail[0].scoreAll),
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addScore", params)
        .then((res) => {
          this.$message({
            message: "评分成功",
            type: "success",
          });
          this.scoreDetail = [
            {
              id: "",
              uname: "",
              title: "",
              detail: "",
              scoreAll: {
                first: "",
                second: "",
                third: "",
                // fourth: "",
                // fivth: "",
                content: "",
              },
              sumScore: 0,
            },
          ];
          this.dialogVisibleScore = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectAnLi() {
      let params = {
        id: this.aid,
      };
      this.ajax
        .get(this.$store.state.api + "selectRaceDetail", params)
        .then((res) => {
          this.anliBox = res.data[0];
          this.anliBox[0].info = JSON.parse(this.anliBox[0].info);
          this.anliBox[0].overview = JSON.parse(this.anliBox[0].overview);
          this.anliBox[0].process = JSON.parse(this.anliBox[0].process);
          this.anliBox[0].proact = JSON.parse(this.anliBox[0].proact);
          this.anliBox[0].proexc = JSON.parse(this.anliBox[0].proexc);
          this.anliBox[0].results = JSON.parse(this.anliBox[0].results);
          var a = this.anliBox[0].info;
          var b = this.anliBox[0].overview;
          var c = this.anliBox[0].process;
          var d = this.anliBox[0].proact;
          var e = this.anliBox[0].proexc;
          var f = this.anliBox[0].results;
          a.imgBox = [];
          b.driQuestion.imgBox = [];
          b.tarDesign.imgBox = [];
          b.actiDesign.imgBox = [];
          e.imgBox = [];
          f.imgBox = [];
          for (var i = 0; i < a.data.length; i++) {
            if (a.data[i].type == 3) {
              a.imgBox.push({
                url: a.data[i].url,
                type: a.data[i].type,
              });
            }
            this.pptImgUrl1.infoData.push({
              url: a.data[i].url,
              type: a.data[i].type,
              id: i + 1,
              name: a.data[i].name,
              proVisible: false,
            });
          }
          for (var i = 0; i < b.driQuestion.data.length; i++) {
            if (b.driQuestion.data[i].type == 3) {
              b.driQuestion.imgBox.push({
                url: b.driQuestion.data[i].url,
                type: b.driQuestion.data[i].type,
              });
            }
            this.pptImgUrl1.overData.driData.push({
              url: b.driQuestion.data[i].url,
              type: b.driQuestion.data[i].type,
              id: i + 1,
              proVisible: false,
            });
          }
          for (var i = 0; i < b.tarDesign.data.length; i++) {
            if (b.tarDesign.data[i].type == 3) {
              b.tarDesign.imgBox.push({
                url: b.tarDesign.data[i].url,
                type: b.tarDesign.data[i].type,
              });
            }
            this.pptImgUrl1.overData.tarData.push({
              url: b.tarDesign.data[i].url,
              type: b.tarDesign.data[i].type,
              id: i + 1,
              proVisible: false,
            });
          }
          for (var i = 0; i < b.actiDesign.data.length; i++) {
            if (b.actiDesign.data[i].type == 3) {
              b.actiDesign.imgBox.push({
                url: b.actiDesign.data[i].url,
                type: b.actiDesign.data[i].type,
              });
            }
            this.pptImgUrl1.overData.actData.push({
              url: b.actiDesign.data[i].url,
              type: b.actiDesign.data[i].type,
              id: i + 1,
              proVisible: false,
            });
          }
          for (var i = 0; i < c.stageBox.length; i++) {
            c.stageBox[i].imgBox = [];
            this.pptImgUrl1.proData[i] = [];
            c.stageBox[i].isFold = "";
            c.stageBox[i].isFold = 0;
            for (var j = 0; j < c.stageBox[i].data.length; j++) {
              if (c.stageBox[i].data[j].type == 3) {
                c.stageBox[i].imgBox.push({
                  url: c.stageBox[i].data[j].url,
                  type: c.stageBox[i].data[j].type,
                });
              }
              this.pptImgUrl1.proData[i].push({
                url: c.stageBox[i].data[j].url,
                type: c.stageBox[i].data[j].type,
                id: j + 1,
                proVisible: false,
              });
            }
            for (var z = 0; z < c.stageBox[i].actBox.length; z++) {
              c.stageBox[i].actBox[z].driQuestion.imgBox = [];
              c.stageBox[i].actBox[z].tarDesign.imgBox = [];
              c.stageBox[i].actBox[z].actiDesign.imgBox = [];
              c.stageBox[i].actBox[z].evaDesign.imgBox = [];
              c.stageBox[i].actBox[z].isFold = "";
              c.stageBox[i].actBox[z].isFold = 0;
              for (
                var k = 0;
                k < c.stageBox[i].actBox[z].driQuestion.data.length;
                k++
              ) {
                if (c.stageBox[i].actBox[z].driQuestion.data[k].type == 3) {
                  c.stageBox[i].actBox[z].driQuestion.imgBox.push({
                    url: c.stageBox[i].actBox[z].driQuestion.data[k].url,
                    type: c.stageBox[i].actBox[z].driQuestion.data[k].type,
                  });
                }
              }
              for (
                var k = 0;
                k < c.stageBox[i].actBox[z].tarDesign.data.length;
                k++
              ) {
                if (c.stageBox[i].actBox[z].tarDesign.data[k].type == 3) {
                  c.stageBox[i].actBox[z].tarDesign.imgBox.push({
                    url: c.stageBox[i].actBox[z].tarDesign.data[k].url,
                    type: c.stageBox[i].actBox[z].tarDesign.data[k].type,
                  });
                }
              }
              for (
                var k = 0;
                k < c.stageBox[i].actBox[z].actiDesign.data.length;
                k++
              ) {
                if (c.stageBox[i].actBox[z].actiDesign.data[k].type == 3) {
                  c.stageBox[i].actBox[z].actiDesign.imgBox.push({
                    url: c.stageBox[i].actBox[z].actiDesign.data[k].url,
                    type: c.stageBox[i].actBox[z].actiDesign.data[k].type,
                  });
                }
              }
              for (
                var k = 0;
                k < c.stageBox[i].actBox[z].evaDesign.data.length;
                k++
              ) {
                if (c.stageBox[i].actBox[z].evaDesign.data[k].type == 3) {
                  c.stageBox[i].actBox[z].evaDesign.imgBox.push({
                    url: c.stageBox[i].actBox[z].evaDesign.data[k].url,
                    type: c.stageBox[i].actBox[z].evaDesign.data[k].type,
                  });
                }
              }
            }
          }
          for (var i = 0; i < e.data.length; i++) {
            if (e.data[i].type == 3) {
              e.imgBox.push({ url: e.data[i].url, type: e.data[i].type });
            }
            this.pptImgUrl1.excData.push({
              url: e.data[i].url,
              type: e.data[i].type,
              id: i + 1,
              proVisible: false,
            });
          }
          for (var i = 0; i < f.data.length; i++) {
            if (f.data[i].type == 3) {
              f.imgBox.push({ url: f.data[i].url, type: f.data[i].type });
            }
            this.pptImgUrl1.effData.push({
              url: f.data[i].url,
              type: f.data[i].type,
              id: i + 1,
              proVisible: false,
            });
          }
          this.lookFile();
          this.reTop();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectNav(n) {
      this.dialogVisibleBrief = true;
      this.briefNav = n;
    },
    onPlayerPlay() {},
    lookFile1(u, t) {
      //1文档2视频3图片
      this.pptImgUrl = "";
      var a = ["PPT", "PPTX", "XLSX", "XLS", "DOC", "DOCX"];
      var c = [
        "BMP",
        "PJP",
        "APNG",
        "PNG",
        "JPG",
        "GIF",
        "SVG",
        "JPEG",
        "JPG",
        "ICO",
        "PGPEG",
        "AVIF",
      ];
      if (
        a.indexOf(u.split(".")[u.split(".").length - 1].toLocaleUpperCase()) !=
        -1
      ) {
        this.pptImgUrl = u;
        this.showPDF = false;
        this.dialogVisible = true;
      } else if (
        u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
      ) {
        this.pptImgUrl = u;
        this.showPDF = true;
        this.dialogVisible = true;
      } else if (
        c.indexOf(u.split(".")[u.split(".").length - 1].toLocaleUpperCase()) !=
        -1
      ) {
        this.previewImg(u);
      } else {
        this.videoDetail = {};
        this.playerOptions.sources[0].src = u;
        this.videoDetail = this.playerOptions;
        this.videoVisible = true;
      }
    },
    lookFile2(u, t, type, i, j) {
      var b = [
        "DOC",
        "DOCX",
        "DOCM",
        "DOTM",
        "DOTX",
        "PPTX",
        "PPSX",
        "PPT",
        "PPS",
        "PPTM",
        "POTM",
        "PPAM",
        "POTX",
        "PPSM",
        "DOT",
        "XLSX",
        "XLS",
      ];
      var c = [
        "BMP",
        "PJP",
        "APNG",
        "PNG",
        "JPG",
        "GIF",
        "SVG",
        "JPEG",
        "JPG",
        "ICO",
        "PGPEG",
        "AVIF",
      ];
      var d = JSON.parse(JSON.stringify(this.playerOptions));
      if (type == 0) {
        if (
          b.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.infoData.showType = 2;
          this.pptImgUrl2.infoData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(u);
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.infoData.showType = 1;
          this.pptImgUrl2.infoData.url = u;
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "ZIP"
        ) {
          this.pptImgUrl2.infoData.showType = 5;
          this.pptImgUrl2.infoData.url = u;
        } else if (
          c.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.infoData.showType = 4;
          this.pptImgUrl2.infoData.url = u;
        } else {
          // this.videoDetail = {};
          // this.playerOptions.sources[0].src = u;
          // this.videoDetail = this.playerOptions;
          this.pptImgUrl2.infoData.showType = 3;
          this.pptImgUrl2.infoData.playerO = d;
          this.pptImgUrl2.infoData.playerO.sources[0].src = u;
        }
        this.pptImgUrl1.fileType.infoType = j + 1;
        this.nameIndex = j;
      } else if (type == 1) {
        if (
          b.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.driData.showType = 2;
          this.pptImgUrl2.overData.driData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(u);
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.overData.driData.showType = 1;
          this.pptImgUrl2.overData.driData.url = u;
        } else if (
          c.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.driData.showType = 4;
          this.pptImgUrl2.overData.driData.url = u;
        } else {
          this.pptImgUrl2.overData.driData.showType = 3;
          this.pptImgUrl2.overData.driData.playerO = d;
          this.pptImgUrl2.overData.driData.playerO.sources[0].src = u;
        }
        this.pptImgUrl1.fileType.overType.driType = j + 1;
      } else if (type == 2) {
        if (
          b.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.tarData.showType = 2;
          this.pptImgUrl2.overData.tarData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(u);
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.overData.tarData.showType = 1;
          this.pptImgUrl2.overData.tarData.url = u;
        } else if (
          c.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.tarData.showType = 4;
          this.pptImgUrl2.overData.tarData.url = u;
        } else {
          this.pptImgUrl2.overData.tarData.showType = 3;
          this.pptImgUrl2.overData.tarData.playerO = d;
          this.pptImgUrl2.overData.tarData.playerO.sources[0].src = u;
        }
        this.pptImgUrl1.fileType.overType.tarType = j + 1;
      } else if (type == 3) {
        if (
          b.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.actData.showType = 2;
          this.pptImgUrl2.overData.actData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(u);
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.overData.actData.showType = 1;
          this.pptImgUrl2.overData.actData.url = u;
        } else if (
          c.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.actData.showType = 4;
          this.pptImgUrl2.overData.actData.url = u;
        } else {
          this.pptImgUrl2.overData.actData.showType = 3;
          this.pptImgUrl2.overData.actData.playerO = d;
          this.pptImgUrl2.overData.actData.playerO.sources[0].src = u;
        }
        this.pptImgUrl1.fileType.overType.actType = j + 1;
      } else if (type == 4) {
        if (
          b.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.proData[i].showType = 2;
          this.pptImgUrl2.proData[i].url =
            "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(u);
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.proData[i].showType = 1;
          this.pptImgUrl2.proData[i].url = u;
        } else if (
          c.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.proData[i].showType = 4;
          this.pptImgUrl2.proData[i].url = u;
        } else {
          this.pptImgUrl2.proData[i].showType = 3;
          this.pptImgUrl2.proData[i].playerO = d;
          this.pptImgUrl2.proData[i].playerO.sources[0].src = u;
        }
        this.pptImgUrl1.fileType.proType = j + 1;
      } else if (type == 5) {
        if (
          b.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.excData.showType = 2;
          this.pptImgUrl2.excData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(u);
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.excData.showType = 1;
          this.pptImgUrl2.excData.url = u;
        } else if (
          c.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.excData.showType = 4;
          this.pptImgUrl2.excData.url = u;
        } else {
          this.pptImgUrl2.excData.showType = 3;
          this.pptImgUrl2.excData.playerO = d;
          this.pptImgUrl2.excData.playerO.sources[0].src = u;
        }
        this.pptImgUrl1.fileType.excType = j + 1;
      } else if (type == 6) {
        if (
          b.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.effData.showType = 2;
          this.pptImgUrl2.effData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(u);
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.effData.showType = 1;
          this.pptImgUrl2.effData.url = u;
        } else if (
          c.indexOf(
            u.split(".")[u.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.effData.showType = 4;
          this.pptImgUrl2.effData.url = u;
        } else {
          this.pptImgUrl2.effData.showType = 3;
          this.pptImgUrl2.effData.playerO = d;
          this.pptImgUrl2.effData.playerO.sources[0].src = u;
        }
        this.pptImgUrl1.fileType.effType = j + 1;
      }
    },
    lookFile() {
      var a = this.pptImgUrl1;
      var b = [
        "DOC",
        "DOCX",
        "DOCM",
        "DOTM",
        "DOTX",
        "PPTX",
        "PPSX",
        "PPT",
        "PPS",
        "PPTM",
        "POTM",
        "PPAM",
        "POTX",
        "PPSM",
        "DOT",
        "XLSX",
        "XLS",
      ];
      var c = [
        "BMP",
        "PJP",
        "APNG",
        "PNG",
        "JPG",
        "GIF",
        "SVG",
        "JPEG",
        "JPG",
        "ICO",
        "PGPEG",
        "AVIF",
      ];
      var d = JSON.parse(JSON.stringify(this.playerOptions));
      this.pptImgUrl2.infoData = a.infoData ? a.infoData[0] : {};
      if (a.infoData.length > 0) {
        if (
          b.indexOf(
            this.pptImgUrl2.infoData.url
              .split(".")
              [
                this.pptImgUrl2.infoData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.infoData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(this.pptImgUrl2.infoData.url);
          this.pptImgUrl2.infoData.showType = 2;
        } else if (
          this.pptImgUrl2.infoData.url
            .split(".")
            [
              this.pptImgUrl2.infoData.url.split(".").length - 1
            ].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.infoData.showType = 1;
        } else if (
          u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "ZIP"
        ) {
          this.pptImgUrl2.infoData.showType = 5;
          this.pptImgUrl2.infoData.url = u;
        } else if (
          c.indexOf(
            this.pptImgUrl2.infoData.url
              .split(".")
              [
                this.pptImgUrl2.infoData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.infoData.showType = 4;
        } else {
          // this.videoDetail = {};
          // this.playerOptions.sources[0].src = u;
          // this.videoDetail = this.playerOptions;
          this.pptImgUrl2.infoData.playerO = d;
          this.pptImgUrl2.infoData.playerO.sources[0].src =
            this.pptImgUrl2.infoData.url;
          this.pptImgUrl2.infoData.showType = 3;
        }
        this.pptImgUrl1.fileType.infoType = 1;
      }

      this.pptImgUrl2.overData.driData = a.overData.driData
        ? a.overData.driData[0]
        : {};
      if (a.overData.driData.length > 0) {
        if (
          b.indexOf(
            this.pptImgUrl2.overData.driData.url
              .split(".")
              [
                this.pptImgUrl2.overData.driData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.driData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(this.pptImgUrl2.overData.driData.url);
          this.pptImgUrl2.overData.driData.showType = 2;
        } else if (
          this.pptImgUrl2.overData.driData.url
            .split(".")
            [
              this.pptImgUrl2.overData.driData.url.split(".").length - 1
            ].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.overData.driData.showType = 1;
        } else if (
          c.indexOf(
            this.pptImgUrl2.overData.driData.url
              .split(".")
              [
                this.pptImgUrl2.overData.driData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.driData.showType = 4;
        } else {
          this.pptImgUrl2.overData.driData.playerO = d;
          this.pptImgUrl2.overData.driData.playerO.sources[0].src =
            this.pptImgUrl2.overData.driData.url;
          this.pptImgUrl2.overData.driData.showType = 3;
        }
        this.pptImgUrl1.fileType.overType.driType = 1;
      }

      this.pptImgUrl2.overData.tarData = a.overData.tarData
        ? a.overData.tarData[0]
        : {};
      if (a.overData.tarData.length > 0) {
        if (
          b.indexOf(
            this.pptImgUrl2.overData.tarData.url
              .split(".")
              [
                this.pptImgUrl2.overData.tarData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.tarData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(this.pptImgUrl2.overData.tarData.url);
          this.pptImgUrl2.overData.tarData.showType = 2;
        } else if (
          this.pptImgUrl2.overData.tarData.url
            .split(".")
            [
              this.pptImgUrl2.overData.tarData.url.split(".").length - 1
            ].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.overData.tarData.showType = 1;
        } else if (
          c.indexOf(
            this.pptImgUrl2.overData.tarData.url
              .split(".")
              [
                this.pptImgUrl2.overData.tarData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.tarData.showType = 4;
        } else {
          this.pptImgUrl2.overData.tarData.playerO = d;
          this.pptImgUrl2.overData.tarData.playerO.sources[0].src =
            this.pptImgUrl2.overData.tarData.url;
          this.pptImgUrl2.overData.tarData.showType = 3;
        }
        this.pptImgUrl1.fileType.overType.tarType = 1;
      }

      this.pptImgUrl2.overData.actData = a.overData.actData
        ? a.overData.actData[0]
        : {};
      if (a.overData.actData.length > 0) {
        if (
          b.indexOf(
            this.pptImgUrl2.overData.actData.url
              .split(".")
              [
                this.pptImgUrl2.overData.actData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.actData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(this.pptImgUrl2.overData.actData.url);
          this.pptImgUrl2.overData.actData.showType = 2;
        } else if (
          this.pptImgUrl2.overData.actData.url
            .split(".")
            [
              this.pptImgUrl2.overData.actData.url.split(".").length - 1
            ].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.overData.actData.showType = 1;
        } else if (
          c.indexOf(
            this.pptImgUrl2.overData.actData.url
              .split(".")
              [
                this.pptImgUrl2.overData.actData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.overData.actData.showType = 4;
        } else {
          this.pptImgUrl2.overData.actData.playerO = d;
          this.pptImgUrl2.overData.actData.playerO.sources[0].src =
            this.pptImgUrl2.overData.actData.url;
          this.pptImgUrl2.overData.actData.showType = 3;
        }
        this.pptImgUrl1.fileType.overType.actType = 1;
      }
      for (var i = 0; i < a.proData.length; i++) {
        this.pptImgUrl2.proData[i] = a.proData[i] ? a.proData[i][0] : {};
        if (a.proData[i].length > 0) {
          if (
            b.indexOf(
              this.pptImgUrl2.proData[i].url
                .split(".")
                [
                  this.pptImgUrl2.proData[i].url.split(".").length - 1
                ].toLocaleUpperCase()
            ) != -1
          ) {
            this.pptImgUrl2.proData[i].url =
              "https://view.officeapps.live.com/op/view.aspx?src=" +
              encodeURIComponent(this.pptImgUrl2.proData[i].url);
            this.pptImgUrl2.proData[i].showType = 2;
          } else if (
            this.pptImgUrl2.proData[i].url
              .split(".")
              [
                this.pptImgUrl2.proData[i].url.split(".").length - 1
              ].toLocaleUpperCase() == "PDF"
          ) {
            this.pptImgUrl2.proData[i].showType = 1;
          } else if (
            c.indexOf(
              this.pptImgUrl2.proData[i].url
                .split(".")
                [
                  this.pptImgUrl2.proData[i].url.split(".").length - 1
                ].toLocaleUpperCase()
            ) != -1
          ) {
            this.pptImgUrl2.proData[i].showType = 4;
          } else {
            this.pptImgUrl2.proData[i].playerO = d;
            this.pptImgUrl2.proData[i].playerO.sources[0].src =
              this.pptImgUrl2.proData[i].url;
            this.pptImgUrl2.proData[i].showType = 3;
          }
          this.pptImgUrl1.fileType.proType = 1;
        }
      }
      this.pptImgUrl2.excData = a.excData ? a.excData[0] : {};
      if (a.excData.length > 0) {
        if (
          b.indexOf(
            this.pptImgUrl2.excData.url
              .split(".")
              [
                this.pptImgUrl2.excData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.excData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(this.pptImgUrl2.excData.url);
          this.pptImgUrl2.excData.showType = 2;
        } else if (
          this.pptImgUrl2.excData.url
            .split(".")
            [
              this.pptImgUrl2.excData.url.split(".").length - 1
            ].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.excData.showType = 1;
        } else if (
          c.indexOf(
            this.pptImgUrl2.excData.url
              .split(".")
              [
                this.pptImgUrl2.excData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.excData.showType = 4;
        } else {
          this.pptImgUrl2.excData.playerO = d;
          this.pptImgUrl2.excData.playerO.sources[0].src =
            this.pptImgUrl2.excData.url;
          this.pptImgUrl2.excData.showType = 3;
        }
        this.pptImgUrl1.fileType.excType = 1;
      }
      this.pptImgUrl2.effData = a.effData ? a.effData[0] : {};
      if (a.effData.length > 0) {
        if (
          b.indexOf(
            this.pptImgUrl2.effData.url
              .split(".")
              [
                this.pptImgUrl2.effData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.effData.url =
            "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(this.pptImgUrl2.effData.url);
          this.pptImgUrl2.effData.showType = 2;
        } else if (
          this.pptImgUrl2.effData.url
            .split(".")
            [
              this.pptImgUrl2.effData.url.split(".").length - 1
            ].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl2.effData.showType = 1;
        } else if (
          c.indexOf(
            this.pptImgUrl2.effData.url
              .split(".")
              [
                this.pptImgUrl2.effData.url.split(".").length - 1
              ].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl2.effData.showType = 4;
        } else {
          this.pptImgUrl2.effData.playerO = d;
          this.pptImgUrl2.effData.playerO.sources[0].src =
            this.pptImgUrl2.effData.url;
          this.pptImgUrl2.effData.showType = 3;
        }
        this.pptImgUrl1.fileType.effType = 1;
      }
    },
    downloadFile(url) {
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域
      let url2 = url;
      let _url2 = "";
      if (
        url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
      ) {
        _url2 = url2.split(
          "https://view.officeapps.live.com/op/view.aspx?src="
        )[1];
      } else {
        _url2 = url2;
      }
      const loading2 = this.$loading.service({
        background: "rgba(255, 255, 255, 0.7)",
        target: document.body,
        text: "文件加载中...",
      });
      var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
      let name = decodeURIComponent(_url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1])
      var params = {
        Bucket: "ccrb",
        Key: name
      };
      s3.getObject(params, function (err, data) {
        loading2.close();
        if (err) console.log(err, err.stack); // an error occurred
        else {
          let url = window.URL.createObjectURL(new Blob([data.Body]));
          let a = document.createElement("a");
          a.name = name;
          a.href = url;
          a.download = name;
          a.click();
          console.log(data); 
        }          // sxuccessful response

      });
      
      return;
    },
    jump(t) {
      var a = document.getElementById(t);
      var b = this.$refs["cenBox"];
      if (this.isNavTop >= 300) {
        b.scrollTop = a.offsetTop - 80;
      } else {
        b.scrollTop = a.offsetTop - 150;
      }
    },
    jumpS(i) {
      var a = document.getElementById("jd" + i);
      var b = this.$refs["cenBox"];
      b.scrollTop = a.offsetTop - 70;
    },
    jumpB(i) {
      var a = document.getElementById("jdb" + i);
      var b = this.$refs["cenBox"];
      b.scrollTop = a.offsetTop - 70;
    },
    reTop() {
      var a = this.$refs["cenBox"];
      a.scrollTop = 0;
    },
    allScrollTop(ev) {
      console.log(ev.target.scrollTop);
      this.isNavTop = ev.target.scrollTop;
    },
    fold(i, j, e, type) {
      var a =
        e.currentTarget.parentElement.parentElement.parentElement.parentElement;
      var b = e.currentTarget.parentElement;
      if (type == 1) {
        this.anliBox[0].process.stageBox[j].actBox[i].isFold = 1;
        a.className += " smallTaskBorder";
        b.className += " funBlockTop";
      } else {
        this.anliBox[0].process.stageBox[j].actBox[i].isFold = 0;
        a.className = "jdBox";
        b.className = "funBlock";
      }
      this.$forceUpdate();
    },
    fold1(i, e, type) {
      var a =
        e.currentTarget.parentElement.parentElement.parentElement.parentElement;
      var b = e.currentTarget.parentElement;
      if (type == 1) {
        this.anliBox[0].process.stageBox[i].isFold = 1;
        a.className += " smallTaskBorder";
        b.className += " funBlockTop";
      } else {
        this.anliBox[0].process.stageBox[i].isFold = 0;
        a.className = "jdBox";
        b.className = "funBlock";
      }
      this.$forceUpdate();
    },
    lookBig(u) {
      var b = [
        "DOC",
        "DOCX",
        "DOCM",
        "DOTM",
        "DOTX",
        "PPTX",
        "PPSX",
        "PPT",
        "PPS",
        "PPTM",
        "POTM",
        "PPAM",
        "POTX",
        "PPSM",
        "DOT",
        "XLSX",
        "XLS",
      ];
      var c = [
        "BMP",
        "PJP",
        "APNG",
        "PNG",
        "JPG",
        "GIF",
        "SVG",
        "JPEG",
        "JPG",
        "ICO",
        "PGPEG",
        "AVIF",
      ];
      if (
        b.indexOf(u.split(".")[u.split(".").length - 1].toLocaleUpperCase()) !=
        -1
      ) {
        this.pptImgUrl =
          "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(u);
        this.showPDF = false;
        this.dialogVisible = true;
      } else if (
        u.split(".")[u.split(".").length - 1].toLocaleUpperCase() == "PDF"
      ) {
        this.pptImgUrl = u;
        this.showPDF = true;
        this.dialogVisible = true;
      } else if (
        c.indexOf(u.split(".")[u.split(".").length - 1].toLocaleUpperCase()) !=
        -1
      ) {
        this.previewImg(u);
      } else {
        this.videoDetail = {};
        this.playerOptions.sources[0].src = u;
        this.videoDetail = this.playerOptions;
        this.videoVisible = true;
      }
    },
  },
  computed: {
    selectHeight() {
      //此处不需要携带参数
      return function (i) {
        /** do something */
        //  a = a + 'testforplaceholider'
        var a = document.getElementById(i);
        var b = a && a.clientHeight;
        return b > 500;
      };
    },
  },
  created() {
    this.selectAnLi();
  },
};
</script>

<style scoped>
@media screen and (max-width: 1280px) {
  .file > div > div:nth-child(2) > div:nth-child(1) {
    width: 80px !important;
  }

  .leftImg {
    height: 230px !important;
  }
  .navTop {
    margin: 0 5px !important;
  }
  .navBox {
    margin: 0 0 0 28% !important;
  }
  .messageBox {
    margin: 1% 0 0 28% !important;
  }
  .proOverNav {
    width: 94% !important;
  }
  .look_file {
    width: 55% !important;
  }
  .leftNav {
    top: 60% !important;
    transform: translateY(-25%) !important;
  }
  .isleftNav {
    top: 55% !important;
  }
  .isNavBox {
    left: 22% !important;
  }
}
html,
body {
  background: #e1f1ff !important;
}
.add_student >>> .el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center;
  background: #32455b;
}
.add_student >>> .el-dialog__title {
  font-size: 14px !important;
  color: #fff !important;
}
.add_student >>> .el-dialog__headerbtn {
  font-size: 20px !important;
}
.add_student >>> .el-form-item__label {
  margin-left: 65px;
}
.add_student >>> .el-form-item {
  display: flex;
}
.add_student >>> .el-form-item__content {
  margin: 0 !important;
}
.add_student >>> .el-dialog__footer {
  text-align: center !important;
}
.center_content {
  width: 100%;
  height: 100%;
  background: #e1f1ff;
  overflow: auto;
}
.detaBox {
  padding: 10px 0 0 0;
  background: #e0eaf3;
  position: relative;
  padding-bottom: 50px;
}
.anliMiddle {
  margin: 0 0 15px 0;
  width: 100%;
  background: #fff;
}
.anliImg {
  width: 200px;
  height: 115px;
}
.anliImg > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.people {
  display: flex;
}

.person {
  margin-left: 10px;
  line-height: 18px;
}
.man {
  width: 16px;
  height: 16px;
}

.man > img {
  width: 100%;
  height: 100%;
}
.anliBox {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding: 25px 0 25px 60px;
  position: relative;
}
.anliNav {
  padding-left: 30px;
}
.anliNav > div:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
}
.anliNav > div:nth-child(2) {
  margin: 10px 0 10px 0;
}
.anliNav > div:nth-child(3) {
  display: flex;
  margin-bottom: 10px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.anliNav > div:nth-child(3) > div:nth-child(2) {
  /* color: #aba8a8; */
  margin-left: 35px;
}
.navBox {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  background: #fff;
  width: 60%;
  margin: 0 auto;
  height: 50px;
  border-radius: 5px;
}
.isNavBox {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  /* top: 5%; */
  top: 50px;
  box-shadow: 2px 2px 11px 1px #bdbdbd;
  width: 100%;
  border-radius: 0 !important;
  z-index: 999;
  justify-content: center;
}
.isNavBox > div > div:nth-child(2):hover,
.navBox > div > div:nth-child(2):hover {
  color: #5e5e5e;
}
/* .isMessageBox {
  margin: 11% auto !important;
} */
.navBox > div:nth-child(5) > div:nth-child(2) {
  width: 150px;
}
.navBox > div:nth-child(6) > div:nth-child(2) {
  width: 120px;
}
/* .navBox > div:nth-child(2) > div:nth-child(2),
.navBox > div:nth-child(3) > div:nth-child(2) {
  width: 70px;
} */
.navTop {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0 20px;
  cursor: pointer;
}

.navImg {
  width: 30px;
  height: 30px;
}
.navImg > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.messageBox {
  width: 60%;
  margin: 15px auto;
}
.whiteBg {
  width: 100%;
  background: #fff;
  margin: 20px 0;
  padding-top: 15px;
  border-radius: 5px;
  box-sizing: border-box;
}
.whiteLeft {
  /* width: 64%; */
  margin: 0;
  height: auto;
}
.navBg,
.jdNavBg,
.bigNavBg {
  width: 160px;
  height: 50px;
  background-image: url("../../../../assets/icon/anliDetail/navBg.png");
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
  line-height: 50px;
  margin: 0 0 5px 10px;
  text-indent: 20px;
}
.bigNavBg {
  width: 200px;
  background-image: url("../../../../assets/icon/anliDetail/longNavBg.png");
}
.jdNavBg {
  background-image: url("../../../../assets/icon/anliDetail/jdNavBg.png");
}
.detaBrief {
  padding: 0 0 20px 40px;
  text-indent: 25px;
  width: 90%;
  height: 100px;
  overflow: auto;
  word-break: break-word;
}
.proOverCss {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.fileLook {
  display: flex;
  width: 97%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin: 10px auto 10px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
.look_file {
  background: #fff;
  margin: 10px 20px;
  border-radius: 10px;
  box-sizing: border-box;
  width: 60%;
}
.whiteRight {
  width: 100%;
}
.proOverNav {
  word-break: break-word;
  margin-left: 10px;
  width: 95.5%;
  padding: 0 10px 10px 0;
  border-radius: 5px;
  height: auto;
  /* max-height: 500px; */
  line-height: 30px;
  padding: 10px;
  background: #f7f7f7;
  margin: 10px auto 0;
  /* overflow: auto; */
}
.noImg {
  max-height: 300px;
  min-height: 300px;
  overflow: auto;
  word-break: break-word;
  min-width: 90%;
  padding-left: 30px;
  width: 90%;
}
.fileTop {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.fileTopAll {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  background: #2f89dd;
  color: #fff;
  height: 38px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 0 0 0 19px;
  font-size: 14px;
}
.fileTopAll >>> .el-button {
  margin-right: 20px;
  padding: 5px 15px;
}
.fileListImg {
  width: 25px;
  height: 25px;
}
.fileListImg > img {
  width: 100%;
  height: 100%;
}
.fileBox {
  background: #fff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  width: 35%;
  margin-left: 10px;
}
.fileList {
  width: 100%;
  background: #f6f9fe;
  margin: 0 auto;
  border-radius: 10px;
  height: 800px;
  overflow-y: auto;
  overflow-x: hidden;
}
.isVfileList {
  height: 400px;
}
.file {
  padding: 10px;
}
.file > .fileCss {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 2px 2px 13px 1px #e1e1e1;
}
.file > div > div:nth-child(1) {
  background: #0c74ab;
  color: #fff;
  width: 95px;
  min-width: 95px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.file > div > div:nth-child(2) {
  background: #fff;
  height: 45px;
  width: calc(100% - 105px);
  line-height: 45px;
  padding-left: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  position: relative;
}
.file > div > div:nth-child(2) > div:nth-child(1) {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.file > div > div:nth-child(2) > div:nth-child(1):hover {
  color: #5e5e5e;
}
.hdTop {
  position: relative;
  width: 100%;
  height: 60px;
}
.longNavBg {
  width: calc(100% - 30px);
  background-image: linear-gradient(90deg, #52c6ff, #18adff);
  color: #fff;
  height: 60px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding-left: 30px;
  position: absolute;
  z-index: 999;
}
.longNavBg > div:nth-child(1) {
  width: 8px;
  height: 8px;
  background: #ffeb24;
  border-radius: 50%;
  margin-right: 15px;
}
.longNavBg > div:nth-child(2) {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.returnAnLi {
  background: #205cc6;
  width: 70px;
  height: 30px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  margin-right: 20px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
}
.fixBottom {
  position: fixed;
  width: 100%;
  height: 50px;
  background: #fff;
  bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  box-shadow: 2px 2px 13px 1px #e1e1e1;
  z-index: 999;
}
.noFile {
  width: 200px;
  margin: 0 auto;
  padding: 20px 0 0 0;
}
.noFile > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.navBgTop {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 97%;
  margin-left: 15px;
  height: 35px;
}
.navBgTop >>> .el-button {
  height: 35px;
  line-height: 11px;
}
.header-title {
  display: flex;
}
.logoImg {
  width: 30px;
}
.logoImg > img {
  width: 100%;
  height: 100%;
}
.title_add_student {
  margin: 0 auto;
  color: #fff;
}
.fullStyle >>> .el-dialog__body {
  height: 100% !important;
}

.fullStyle >>> .el-dialog,
.fullStyle {
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}
.dialog_diy >>> .el-dialog__header,
.dialog_diy1 >>> .el-dialog__header,
.customWidth1 >>> .el-dialog__header {
  background: #454545 !important;
  padding: 15px 20px;
}

.dialog_diy >>> .el-dialog__title,
.dialog_diy1 >>> .el-dialog__title,
.customWidth1 >>> .el-dialog__title {
  color: #fff;
}

.dialog_diy >>> .el-dialog__headerbtn,
.dialog_diy1 >>> .el-dialog__headerbtn,
.customWidth1 >>> .el-dialog__headerbtn {
  top: 19px;
}

.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close,
.dialog_diy1 >>> .el-dialog__headerbtn .el-dialog__close,
.customWidth1 >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close:hover,
.dialog_diy1 >>> .el-dialog__headerbtn .el-dialog__close:hover,
.customWidth1 >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}

.dialog_diy1 >>> .el-dialog__body {
  padding: 0;
}

.dialog_diy >>> .el-dialog__body,
.dialog_diy >>> .el-dialog__footer,
.dialog_diy1 >>> .el-dialog__footer {
  background: #fafafa;
}
.dialog_diy >>> .el-dialog__body {
  height: 100%;
}
.dialog_diy >>> .el-dialog {
  margin-top: 0 !important;
  height: 100% !important;
}

/* .video-player >>> .video-js {
  height: 400px;
} */
/* .video-player >>> .video-js .vjs-tech {
  height: 400px;
} */
.downFile {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 8px;
  cursor: pointer;
  top: 8px;
}
.leftBox {
  width: 40%;
  padding: 0 0 0 35px;
}
.leftImg {
  width: 100%;
  height: 300px;
  cursor: pointer;
}
.downFile > img,
.leftImg > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.imgAndNav {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  width: 100%;
  padding: 0 0 10px 0;
}
.jdTopBox {
  background: #fff;
  border-radius: 5px;
  /* padding: 20px; */
  margin: 5px 0;
}
.jdTopNav {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.jdLeftNav {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.jdImg {
  width: 30px;
  height: 30px;
}
.jdImg > img {
  width: 100%;
  height: 100%;
}
.jdLeftTitle {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-left: 10px;
  color: #707078;
}
.jdLeftTitle > div:nth-child(2) {
  margin-left: 5px;
}
.jdRightNav {
  padding-right: 95px;
  color: #7e7e7e;
}
.personAndAutor {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-end;
}
.autorBox {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: baseline;
  margin-left: 35px;
}
.Autor {
  margin: 0 5px;
}
.isNoMessage {
  width: 20%;
  margin: 5% auto 0;
}

.isNoMessage > img {
  width: 100%;
  height: 100%;
}
/* code 样式 */
.noImg >>> code,
.detailTable >>> code,
.proOverNav >>> code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}

.noImg >>> pre code,
.detailTable >>> pre code,
.proOverNav >>> pre code {
  display: block;
}

/* ul ol 样式 */
.noImg >>> ul,
ol,
.detailTable >>> ul,
ol,
.proOverNav >>> ul,
ol {
  margin: 10px 0 10px 20px;
}
/* table 样式 */
.noImg >>> table,
.detailTable >>> table,
.proOverNav >>> table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.noImg >>> table td,
.noImg >>> table th,
.detailTable >>> table td,
.detailTable >>> table th,
.proOverNav >>> table td,
.proOverNav >>> table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 15px 5px;
  max-width: 0px;
}

.noImg >>> table th,
.detailTable >>> table th,
.proOverNav >>> table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}

/* blockquote 样式 */
.noImg >>> blockquote,
.detailTable >>> blockquote,
.proOverNav >>> blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

.smallTaskBorder {
  height: 65px;
  min-height: 65px !important;
  overflow: hidden;
}

.funBlock {
  display: flex;
  padding: 15px 0;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  right: 0;
}

.fold {
  margin-right: 10px;
  cursor: pointer;
}

.arrow > img {
  width: 100%;
  height: 100%;
}

.arrow {
  width: 15px;
  height: 15px;
  margin-left: 10px;
}
.returnTop {
  position: fixed;
  bottom: 5%;
  right: 5%;
  transform: translateY(-5%);
  background: #7b9ad7;
  color: #fff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 12px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
}
.upCss {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.leftNav {
  position: fixed;
  left: 4%;
  top: 75%;
  transform: translateY(-60%);
  z-index: 999;
  max-width: 225px;
  height: calc(100% - 169px - 50px);
}
.topNav {
  background: #316b8c;
  color: #fff;
  height: 40px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  line-height: 40px;
  padding-left: 10px;
}
.navLeftBox {
  width: 100%;
  font-size: 1em;
  margin: 0px;
  color: rgb(39, 48, 59);
  background-color: rgb(118, 184, 222);
  display: grid;
  gap: 10px;
  padding: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-sizing: border-box;
  height: 70%;
  overflow-y: auto;
  overflow-x: hidden;
}
.navBTitle {
  background: #fff;
  font-size: 16px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  font-weight: bold;
  text-indent: 15px;
  cursor: pointer;
  max-width: 205px;
  padding-right: 5px;
}
.navBTitle:hover,
.navLTitle:hover {
  color: #5e5e5e;
}
.navLTitle {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  background: #fff;
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
  max-width: 205px;
  padding-right: 5px;
}
.navLTitle > div:nth-child(1) {
  min-width: 50px;
  text-align: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  background-color: rgb(225, 237, 247);
}
.navLTitle > div:nth-child(2) {
  margin-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  max-width: 130px;
}
.navLTitle > div:nth-child(2):hover {
  color: #5e5e5e;
}
.isleftNav {
  top: 65%;
}

.navLeftBox::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
.navLeftBox::-webkit-scrollbar {
  border-radius: 10px;
  background-color: #b8bdc9;
}

/*定义滑块 内阴影+圆角*/
.navLeftBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(96, 125, 184);
  background-color: #595a5a;
}
.jdBox {
  background: #ffff;
  border-radius: 10px;
  padding: 20px 0;
}
.openTaskActive {
  color: #4386e6;
}
.jdChildCss {
  margin: 5px 0px;
}

.getScore >>> .el-button {
  background: #2268bd;
  border-radius: 50%;
  color: #fff;
  position: fixed;
  width: 70px;
  height: 70px;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
}
.customWidth1 >>> .el-dialog {
  min-width: 800px !important;
}
.scoreBox {
  background: #fff;
}
.scoreCss {
  padding: 10px;
}
.scoreTitle {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.scoreTitle > div:nth-child(1) {
  width: 50px;
}
.scoreTitle > div:nth-child(1) > img {
  width: 100%;
  height: 100%;
}
.scoreTitle > div:nth-child(2) {
  margin-left: 15px;
}
.anliTitle,
.anliBrief,
.anliScore {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  font-size: 18px;
}
.anliTitle > div:nth-child(1),
.anliBrief > div:nth-child(1) {
  min-width: 75px;
  width: 75px;
}
.anliTitle > div:nth-child(2),
.anliBrief > div:nth-child(2) {
  font-size: 17px;
  margin-left: 35px;
  color: #b0b0b0;
}
.anliScore > div:nth-child(2) {
  margin: -13px 0 0 20px;
}
.scoreDiv {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding: 10px 0;
}
.scoreDiv > div:nth-child(1) {
  min-width: 90px;
  width: 90px;
}
.scoreDiv > div:nth-child(2) {
  margin-left: 10px;
}
.scoreDiv > div:nth-child(2) >>> .el-input__inner {
  border-radius: 15px;
  background: #fafafa;
  height: 30px;
  font-size: 16px;
}
.anliContent {
  width: 80%;
  margin: 0 auto;
  border-top: 2px solid #ededed;
  padding: 10px 0 0 0;
}
.tAreaCss {
  resize: none;
  width: 100%;
  text-indent: 10px;
  border: 1px solid #e6e6e8;
  background: #fafafa;
}
.tAreaCss:focus-visible {
  outline: none !important;
}
.addScore {
  width: 75%;
  margin: 10px auto;
  background: #409efe;
  color: #fff;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 5px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/race/eventCenter/anliDetail.vue